webpackJsonp([0],{

/***/ "+0bE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.preloading)?_c('Preloader'):_vm._e()],1),_c('Navigation'),_c('router-view'),_c('SVGicons'),(!_vm.preloading)?_vm._m(0):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ParticlesJS')}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+T00":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+h1m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+mpb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SectionHello',

  methods: {
    // Scroll It! - for the User Experience, lul
    hideScrollTip: function hideScrollTip() {
      if (window.scrollY >= 65) {
        document.getElementById('Hello').classList.add('hidden-scrolltip');
      } else {
        document.getElementById('Hello').classList.remove('hidden-scrolltip');
      }
    }
  },

  created: function created() {
    window.addEventListener('scroll', this.hideScrollTip);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.hideScrollTip);
  }
});

/***/ }),

/***/ "+nHM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+vQS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/51V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Techs_vue__ = __webpack_require__("yXwe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_300c9966_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Techs_vue__ = __webpack_require__("bA5C");
function injectStyle (ssrContext) {
  __webpack_require__("bgqR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Techs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_300c9966_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Techs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0QNm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1+i5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMwIiBoZWlnaHQ9IjQ1NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTIxNi40NjI4NTcgNDcuNjQyMTI5bDE2NS4xMyA1Ny4zOTAyNDRjMS4zNjQwNDguNDgxNTk2IDIuMTY2NDI5IDEuNzY1ODUzIDIuMDA1OTUzIDMuMjEwNjQybC0yNS45OTcxNDMgMjE3LjQ0MDc5OWMtLjA4MDIzOC45NjMxOTMtLjY0MTkwNSAxLjc2NTg1My0xLjQ0NDI4NiAyLjI0NzQ1bC0xMzkuMTMyODU3IDgwLjE4NTgwOWMtLjQ4MTQyOS4yNDA3OTgtLjk2Mjg1Ny40MDEzMzEtMS40NDQyODYuNDAxMzMxVjQ3LjQ4MTU5NmMuMjQwNzE0IDAgLjU2MTY2Ny4wODAyNjcuODgyNjE5LjE2MDUzMyIgZmlsbD0iI0E5MjExRiIvPgogICAgPHBhdGggZD0iTTIxNC41MzcxNDMgNDcuNjQyMTI5bC0xNjUuMTMgNTcuMzkwMjQ0Yy0xLjM2NDA0OC40ODE1OTYtMi4xNjY0MjkgMS43NjU4NTMtMi4wMDU5NTMgMy4yMTA2NDJsMjUuOTk3MTQzIDIxNy40NDA3OTljLjA4MDIzOC45NjMxOTMuNjQxOTA1IDEuNzY1ODUzIDEuNDQ0Mjg2IDIuMjQ3NDVsMTM5LjEzMjg1NyA4MC4xODU4MDljLjQ4MTQyOS4yNDA3OTguOTYyODU3LjQwMTMzMSAxLjUyNDUyNC40MDEzMzFWNDcuNDgxNTk2Yy0uMzIwOTUyIDAtLjY0MTkwNS4wODAyNjctLjk2Mjg1Ny4xNjA1MzMiIGZpbGw9IiNFMzMxMzEiLz4KICAgIDxwYXRoIGZpbGw9IiNEMkQyRDIiIGQ9Ik0yNDguNTU4MDk1IDIzMC4wMDY2NTJMMjE1LjUgMTU4LjczMDM3N1Y4Ny44NTU0MzJsMTAzLjQyNjkwNSAyMjIuODk4ODkyaC0zNC4wMjA5NTNsLTIzLjI2OTA0Ny01MC45Njg5NThIMjE1LjV2LTI5Ljc3ODcxNCIvPgogICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTI0OC41NTgwOTUgMjMwLjAwNjY1MkwyMTUuNSAxNTguNzMwMzc3Vjg3Ljg1NTQzMmwxMDMuNDI2OTA1IDIyMi44OTg4OTJoLTM0LjAyMDk1M2wtMjMuMjY5MDQ3LTUwLjk2ODk1OEgyMTUuNXYtMjkuNzc4NzE0bS0zMy4wNTgwOTUgMEwyMTUuNSAxNTguNzMwMzc3Vjg3Ljg1NTQzMkwxMTEuOTkyODU3IDMxMC43NTQzMjRoMzQuMDIwOTUybDIzLjI2OTA0OC01MC45Njg5NThIMjE1LjV2LTI5Ljc3ODcxNCIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "17x+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _mutations;



var state = {
  projects: null,
  currentProject: null
};

var getters = {
  getProjects: function getProjects(state) {
    return state.projects;
  },
  getCurrentProject: function getCurrentProject(state) {
    return state.currentProject;
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* STORE_PROJECTS */], function (state, projectsState) {
  state.projects = projectsState;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_CURRENT_PROJECT */], function (state, currentProjectState) {
  state.currentProject = currentProjectState;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),

/***/ "18NO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMwIiBoZWlnaHQ9IjQ1NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZmlsbD0iIzU2M0Q3QyIgZD0iTTc5LjA3OCA5MS4zNTFoMjczLjE5NFYzNjUuMzdINzkuMDc4eiIvPgogICAgPHBhdGggZD0iTTIxNy43MzkgMjA5LjMxOGM2Ljk3NyAwIDEyLjI2Ny0xLjUxNiAxNS44Ny00LjU0OCAzLjYwNC0zLjAzMiA1LjQwNi03LjUwNCA1LjQwNi0xMy40MTYgMC01LjgzNi0xLjgwMi0xMC4yNy01LjQwNi0xMy4zMDItMy42MDMtMy4xMDctOC44OTMtNC42Ni0xNS44Ny00LjY2MWgtMjQuNDk3djM1LjkyN2gyNC40OTdtMS40OTUgNzQuMjRjOC44OTMgMCAxNS41NjQtMS44NTcgMjAuMDEtNS41NyA0LjUyNC0zLjcxNSA2Ljc4Ni05LjMyMyA2Ljc4Ni0xNi44MjcgMC03LjM1Mi0yLjIyNC0xMi44NDctNi42Ny0xNi40ODUtNC40NDctMy43MTQtMTEuMTU2LTUuNTcxLTIwLjEyNi01LjU3MWgtMjUuOTkydjQ0LjQ1M2gyNS45OTJtNDEuMTcyLTYxLjA1MmM5LjUwNyAyLjcyOCAxNi44NjcgNy43NjkgMjIuMDggMTUuMTIgNS4yMTQgNy4zNTMgNy44MjEgMTYuMzcyIDcuODIxIDI3LjA2IDAgMTYuMzcxLTUuNTk3IDI4LjU3NC0xNi43OSAzNi42MDgtMTEuMTk1IDguMDM0LTI4LjIxNSAxMi4wNTItNTEuMDYzIDEyLjA1MmgtNzMuNDg5VjE0My42MDRoNjYuNDc0YzIzLjg0NCAwIDQxLjA5NSAzLjU2MiA1MS43NTIgMTAuNjg3IDEwLjczNCA3LjEyNSAxNi4xIDE4LjUzMiAxNi4xIDM0LjIyIDAgOC4yNjMtMS45NTQgMTUuMzEyLTUuODY0IDIxLjE0OC0zLjkxIDUuNzYtOS41ODQgMTAuMDQyLTE3LjAyMSAxMi44NDciIGZpbGw9IiNGRkYiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "1EgX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,style:(_vm.styles),on:{"click":_vm.back}},[_vm._t("default",[_c('div',{class:_vm.innerClasses},[_c('svg',{staticStyle:{"fill":"white"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"53","height":"20"}},[_c('path',{attrs:{"d":"M43.886 16.221l-1.189 1.466L26.5 4.731 10.303 17.688l-1.189-1.467L26.5 2.312z"}})])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1nuo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2IDB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__("iNFr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cbfc25a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__("BeoE");
function injectStyle (ssrContext) {
  __webpack_require__("0QNm")
  __webpack_require__("aP63")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cbfc25a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cbfc25a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Wbp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3hlQ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "40wY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger"},[_c('div',{staticClass:"hamburger__line hamburger__line--01"},[_c('div',{staticClass:"hamburger__line-in hamburger__line-in--01"})]),_c('div',{staticClass:"hamburger__line hamburger__line--02"},[_c('div',{staticClass:"hamburger__line-in hamburger__line-in--02"})]),_c('div',{staticClass:"hamburger__line hamburger__line--03"},[_c('div',{staticClass:"hamburger__line-in hamburger__line-in--03"})]),_c('div',{staticClass:"hamburger__line hamburger__line--cross01"},[_c('div',{staticClass:"hamburger__line-in hamburger__line-in--cross01"})]),_c('div',{staticClass:"hamburger__line hamburger__line--cross02"},[_c('div',{staticClass:"hamburger__line-in hamburger__line-in--cross02"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "579f":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "86rk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",attrs:{"itemscope":"itemscope","itemtype":"https://schema.org/WPFooter"}},[_c('div',{staticClass:"footer-container"},[_c('div',{staticClass:"footer-text"},[_c('span',[_vm._v("Design & "),_c('strike',[_vm._v("in")]),_vm._v(" Development by Jorge Moliner.")],1),_c('span',[_vm._v("© Copyrights 2018. All Rights Reserved.")])])]),_c('BackTop')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "98sf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9W74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export oneOf */
/* unused harmony export camelcaseToHyphen */
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollTop;
//
function oneOf(value, validList) {
  for (var i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
}

//
function camelcaseToHyphen(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

// scrollTop animation
function scrollTop(el) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var to = arguments[2];
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 1000 / 60);
    };
  }
  var difference = Math.abs(from - to);
  var step = Math.ceil(difference / duration * 50);

  function scroll(start, end, step) {
    if (start === end) return;

    var d = start + step > end ? end : start + step;
    if (start > end) {
      d = start - step < end ? end : start - step;
    }

    if (el === window) {
      window.scrollTo(d, d);
    } else {
      el.scrollTop = d;
    }
    window.requestAnimationFrame(function () {
      return scroll(d, end, step);
    });
  }
  scroll(from, to, step);
}

/***/ }),

/***/ "AeN2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticlesJS_vue__ = __webpack_require__("KGQ5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_618d3230_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ParticlesJS_vue__ = __webpack_require__("QcEB");
function injectStyle (ssrContext) {
  __webpack_require__("yNml")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticlesJS_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_618d3230_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ParticlesJS_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AmHV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__konami_code__ = __webpack_require__("IjD7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BounceSpinner__ = __webpack_require__("fcCK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ParticlesJS__ = __webpack_require__("AeN2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SocialNetworks__ = __webpack_require__("V9Zr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BackTop__ = __webpack_require__("sU8K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Revealer__ = __webpack_require__("bxa7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SectionTitle__ = __webpack_require__("v9ZF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_progressbar__ = __webpack_require__("zYko");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_in_viewport_directive__ = __webpack_require__("VYcz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_in_viewport_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_in_viewport_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_on_click_outside__ = __webpack_require__("YccO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_touch__ = __webpack_require__("I0MY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_touch__);





// Custom components







//
// Third party stuff
//
// vue-progressbar (https://github.com/hilongjw/vue-progressbar)

// vue-in-viewport (https://github.com/BKWLD/vue-in-viewport-directive)

// vue-on-click-outside (https://github.com/kmohrf/vue-on-click-outside)

// vue-touch (https://github.com/vuejs/vue-touch)


//
// Usage
//
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_progressbar___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_touch___default.a, { name: 'v-touch' });
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].directive('in-viewport', __WEBPACK_IMPORTED_MODULE_10_vue_in_viewport_directive___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].directive('on-click-outside', __WEBPACK_IMPORTED_MODULE_11_vue_on_click_outside__["directive"]);

// Register custom components for general usage
var myComponents = {
  KonamiCode: __WEBPACK_IMPORTED_MODULE_2__konami_code__["a" /* default */],
  ParticlesJS: __WEBPACK_IMPORTED_MODULE_4__components_ParticlesJS__["a" /* default */],
  SectionTitle: __WEBPACK_IMPORTED_MODULE_8__components_SectionTitle__["a" /* default */],
  Revealer: __WEBPACK_IMPORTED_MODULE_7__components_Revealer__["a" /* default */],
  SocialNetworks: __WEBPACK_IMPORTED_MODULE_5__components_SocialNetworks__["a" /* default */],
  BounceSpinner: __WEBPACK_IMPORTED_MODULE_3__components_BounceSpinner__["a" /* default */],
  BackTop: __WEBPACK_IMPORTED_MODULE_6__components_BackTop__["a" /* default */]
};
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(myComponents).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component(key, myComponents[key]);
});

/***/ }),

/***/ "BJ41":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMwIiBoZWlnaHQ9IjQ1NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTMzNi40Mzg4NjMgODJIOTYuNTYxMTM3QzgxLjg5MTY4IDgyIDcwIDkzLjg5MTY4IDcwIDEwOC41NjExMzd2MjM5Ljg3NzcyNkM3MCAzNjMuMTA4MzIgODEuODkxNjggMzc1IDk2LjU2MTEzNyAzNzVoMjM5Ljg3NzcyNkMzNTEuMTA4MzIgMzc1IDM2MyAzNjMuMTA4MzIgMzYzIDM0OC40Mzg4NjNWMTA4LjU2MTEzN0MzNjMgOTMuODkxNjggMzUxLjEwODMyIDgyIDMzNi40Mzg4NjMgODIiIGZpbGw9IiNEQzM5NUYiLz4KICAgIDxwYXRoIGQ9Ik0xNjcuOTIwMzcxIDE3NC4xODYyN2M5LjczOTk2MSAwIDE3Ljg5OTMyNC03LjYzNDAyNCAxNy44OTkzMjQtMTcuNjM5NTE2IDAtOS45OTg2MjUtOC4xNTkzNjMtMTcuNjMxNTA0LTE3Ljg5OTMyNC0xNy42MzE1MDQtOS43Mzk5NiAwLTE3Ljg5NzAzNSA3LjYzMjg3OS0xNy44OTcwMzUgMTcuNjMxNTA0IDAgMTAuMDA0MzQ4IDguMTU3MDc0IDE3LjYzOTUxNiAxNy44OTcwMzUgMTcuNjM5NTE2bS0zNy4xMTI1NyA5NC40NDY3MThjLTEuMDUxODI0IDQuNDc1MTE3LTEuNTc5NDUzIDkuMzA3MzI4LTEuNTc5NDUzIDEzLjI0OTA5NCAwIDE1LjUzMjQzNCA4LjQyMjYwNSAyNS44NDM1MTYgMjYuMzIxOTMgMjUuODQzNTE2IDE0Ljg0NDU3IDAgMjYuODc5MzE2LTguODE1MTggMzUuNTQ0NTYyLTIzLjA0OTcxNWwtNS4yOTExNjggMjEuMjM0NDg4aDI5LjQ3NzQwMmwxNi44NDc1LTY3LjU3MTk4YzQuMjExODc1LTE3LjEwODQ1MyAxMi4zNzEyMzgtMjUuOTg4ODcxIDI0Ljc0MzYyMS0yNS45ODg4NzEgOS43Mzg4MTcgMCAxNS43OTIyNDIgNi4wNTY4NTkgMTUuNzkyMjQyIDE2LjA1NTQ4NCAwIDIuODk2ODA5LS4yNjMyNDIgNi4wNTIyODEtMS4zMTYyMSA5LjQ3NTU3NGwtOC42ODY5OTMgMzEuMDU5MTQ1Yy0xLjMxNjIxMSA0LjQ3NTExNy0xLjg0MDQwNiA4Ljk1MjUyMy0xLjg0MDQwNiAxMy4xNjA5NjUgMCAxNC43NDQ5OTYgOC42ODM1NTkgMjUuNTI5OTE0IDI2Ljg0NjEyNSAyNS41Mjk5MTQgMTUuNTMwMTQ1IDAgMjcuOTAwMjM4LTkuOTk3NDgxIDM0Ljc0NDUzNS0zMy45NTEzNzVsLTExLjU4MDM2Ny00LjQ3MDUzOWMtNS43OTEzMjggMTYuMDQ3NDcyLTEwLjc5MjkzIDE4Ljk0ODg1OS0xNC43NDE1NjIgMTguOTQ4ODU5LTMuOTQ4NjMzIDAtNi4wNTQ1NzEtMi42MzAxMzMtNi4wNTQ1NzEtNy44OTE1NDMgMC0yLjM2OTE4LjUyODc3NC00Ljk5ODE2OCAxLjMxNjIxMS04LjE2Mzk0MWw4LjQyNDg5NS0zMC4yNTkxMThjMi4xMDQ3OTMtNy4xMDUyNSAyLjg5NTY2NC0xMy40MDU4OTQgMi44OTU2NjQtMTkuMTk0OTMzIDAtMjIuNjM2NTM5LTEzLjY4ODU5NC0zNC40NTAzOTEtMzAuMjcwNTYzLTM0LjQ1MDM5MS0xNS41MjkgMC0zMS4zMjM1MzEgMTQuMDA3OTE4LTM5LjIxODUwOCAyOC43NTA2MjVsNS43ODkwNC0yNi40NjE1NjJIMTkzLjk2NDE4bC02LjMxNzgxMyAyMy4zMDcyMzRoMjEuMDU4MjMxbC0xMi45Njc1MzkgNTEuOTE1OTM3Yy0xMC4xODI4OTUgMjIuNjM2NTQtMjguODg3OTcgMjMuMDAzOTM0LTMxLjIzNTQwMyAyMi40Nzg1OTQtMy44NTQ3ODEtLjg2OTg0NC02LjMyMDEwMS0yLjMzMzY5OS02LjMyMDEwMS03LjM0MjE2OCAwLTIuODg5OTQxLjUyNjQ4NC03LjA0MTE1NiAxLjg0MjY5NS0xMi4wNDYxOTFsMTkuNzQzMTY0LTc4LjMxMzQwNmgtNTAuMDExNDM3bC02LjMxNzgxMyAyMy4zMDcyMzRoMjAuNzkyN2wtMTMuNDIxOTE5IDU0LjgzOTA3IiBmaWxsPSIjRkZGIi8+CiAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "BeoE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"navigation","itemscope":"itemscope","itemtype":"http://schema.org/WPHeader"}},[_c('hamburger-menu'),_c('div',{staticClass:"content"},[_c('div',{staticClass:"global-menu"},[_c('nav',{staticClass:"global-menu__wrap",attrs:{"role":"navigation","itemscope":"itemscope","itemtype":"http://schema.org/SiteNavigationElement"}},[_c('a',{staticClass:"global-menu__item",on:{"click":function($event){return _vm.goToSection('Uno')}}},[_vm._v("Development")]),_c('a',{staticClass:"global-menu__item",on:{"click":function($event){return _vm.goToSection('Dos')}}},[_vm._v("UX/UI Coding")]),_c('a',{staticClass:"global-menu__item",on:{"click":function($event){return _vm.goToSection('Tres')}}},[_vm._v("Side Projects")]),_c('a',{staticClass:"global-menu__item",on:{"click":function($event){return _vm.goToSection('Contact')}}},[_vm._v("Get in touch")])])]),_c('svg',{staticClass:"shape-overlays",attrs:{"viewBox":"0 0 100 100","preserveAspectRatio":"none"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"gradient1","x1":"0%","y1":"0%","x2":"0%","y2":"100%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#00346B"}}),_c('stop',{attrs:{"offset":"100%","stop-color":"#001933"}})],1),_c('linearGradient',{attrs:{"id":"gradient2","x1":"0%","y1":"0%","x2":"0%","y2":"100%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#110046"}}),_c('stop',{attrs:{"offset":"100%","stop-color":"#32004a"}})],1),_c('linearGradient',{attrs:{"id":"gradient3","x1":"0%","y1":"0%","x2":"0%","y2":"100%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#07093D"}}),_c('stop',{attrs:{"offset":"100%","stop-color":"#141422"}})],1)],1),_c('path',{staticClass:"shape-overlays__path"}),_c('path',{staticClass:"shape-overlays__path"}),_c('path',{staticClass:"shape-overlays__path"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C7b/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMwIiBoZWlnaHQ9IjQ1NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTI1NS4yMTQ5MzUgNzkuMTgxMTVsLTM5LjczNzI5NiA2OC45ODY4MzItMzkuNzM3Mjk2LTY4Ljk4NjgzMkg0My40MDk0ODRsMTcyLjA2ODE1NSAyOTguNzE5OCAxNzIuMDY4MTU1LTI5OC43MTk4eiIgZmlsbD0iIzREQkE4NyIvPgogICAgPHBhdGggZD0iTTI1NS4yMTQ5MzUgNzkuMTgxMTVsLTM5LjczNzI5NiA2OC45ODY4MzItMzkuNzM3Mjk2LTY4Ljk4NjgzMmgtNjMuNTAzNTk3bDEwMy4yNDA4OTMgMTc5LjIzMTUyOUwzMTguNzE4NTMyIDc5LjE4MTE1eiIgZmlsbD0iIzQzNTQ2NiIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "DPpi":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMwIiBoZWlnaHQ9IjQ1NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTIxNiA1N2wxNTEuNzk5NjIzIDg1Ljc1djE3MS41TDIxNiA0MDAgNjQuMjAwMzc3IDMxNC4yNXYtMTcxLjV6Ii8+CiAgICA8cGF0aCBkPSJNMzQwLjY5MTUyNSAzMDguMzMzMjVsLTExOS42ODIxMDkgNjcuNTk5NTgzdi01Mi42NTA1bDc0LjU2ODczOC00MC45NTk5MTYgNDUuMTEzMzcxIDI2LjAxMDgzM3ptOC4xODY4MTgtNy40MDMwODNWMTU5LjU1N2wtNDMuNzk2NjEgMjUuMjM5MDgzVjI3NS42NjI1bDQzLjc5NjYxIDI1LjI2NzY2N3pNOTAuODIxODQ2IDMwOC4zMzMyNWwxMTkuNjgyMTA5IDY3LjU5OTU4M3YtNTIuNjUwNWwtNzQuNTY4NzM4LTQwLjk1OTkxNi00NS4xMTMzNzEgMjYuMDEwODMzem0tOC4xODY4MTgtNy40MDMwODNWMTU5LjU1N2w0My43OTY2MSAyNS4yMzkwODNWMjc1LjY2MjVsLTQzLjc5NjYxIDI1LjI2NzY2N3ptNS4xMjM5MTctMTUwLjUxOTgzNGwxMjIuNzQ1MDEtNjkuMzQzMTY2djUwLjkwNjkxNkwxMzEuODcwNDMzIDE3NS4xNjM1bC0uNjAxMTMuMzQzLTQzLjUxMDM1OC0yNS4wOTYxNjd6bTI1NS45OTU0ODEgMGwtMTIyLjc0NTAxLTY5LjM0MzE2NnY1MC45MDY5MTZsNzguNjMzNTIyIDQzLjE4OTQxNy42MDExMy4zNDMgNDMuNTEwMzU4LTI1LjA5NjE2N3oiIGZpbGw9IiM4RUQ2RkIiLz4KICAgIDxwYXRoIGQ9Ik0yMTAuNTAzOTU1IDMxMS4zMDU5MTdsLTczLjU2Njg1NS00MC4zODgyNXYtODAuMDMzMzM0TDIxMC41MDM5NTUgMjMzLjMwMnY3OC4wMDM5MTdtMTAuNTA1NDYxIDBsNzMuNTY2ODU1LTQwLjM4ODI1di04MC4wMzMzMzRMMjIxLjAwOTQxNiAyMzMuMzAydjc4LjAwMzkxN20tNzkuMDkxNTI1LTEyOS42ODI1ODRsNzMuODUzMTA3LTQwLjU1OTc1IDczLjg1MzEwNyA0MC41NTk3NS03My44NTMxMDcgNDIuNTg5MTY3LTczLjg1MzEwNy00Mi41ODkxNjciIGZpbGw9IiMxQzc4QzAiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "DRa2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Techdesign',

  data: function data() {
    return {
      techsigns: [{ name: 'GreenSock', src: __webpack_require__("bz9I") }, { name: 'Sketch', src: __webpack_require__("IWo5") }, { name: 'Photoshop', src: __webpack_require__("579f") },
      // { name: 'AxureRP', src: require('../assets/images/logos/axurerp.svg') },
      { name: 'Invision', src: __webpack_require__("BJ41") }]
    };
  }
});

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STORE_PROJECTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CURRENT_PROJECT; });
var STORE_PROJECTS = 'STORE_PROJECTS';
var SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT';

/***/ }),

/***/ "GO/W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"Dos"}},[_c('SectionTitle',{attrs:{"color":"#F2E059","seo":"02. Design & UI/UX"}},[_c('span',{attrs:{"slot":"number"},slot:"number"},[_vm._v("2")]),_c('span',{attrs:{"slot":"text1"},slot:"text1"},[_vm._v("Design")]),_c('span',{attrs:{"slot":"text2"},slot:"text2"},[_vm._v("USER EXPERIENCE")])]),_c('blockquote',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}],staticClass:"slogan"},[_vm._v("Bridging the gap between design and code")]),_c('blockquote',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}]},[_vm._v("I enjoy coding fresh "),_c('strong',[_vm._v("web components")]),_vm._v(" following the look and feel of the original designs, minding carefully about "),_c('strong',[_vm._v("UX/UI design")]),_vm._v(" of each project. I do transform the original idea from the graphic design software to the final "),_c('strong',[_vm._v("user interface")]),_vm._v(" on the web browser.")]),_c('Techdesign')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H2jK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Techs__ = __webpack_require__("/51V");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Techs: __WEBPACK_IMPORTED_MODULE_0__components_Techs__["a" /* default */]
  }
});

/***/ }),

/***/ "H5/e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IWo5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMwIiBoZWlnaHQ9IjQ1NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZmlsbD0iI0ZEQjMwMCIgZD0iTTEyOS43MDAwMiA5OC4zMzAwMTdsODYuNzE0NDg4LTkuMTk1ODMyIDg2LjcxNDQ4NyA5LjE5NTgzMiA2Ny4xMzM3OTcgOTAuMzk5NzEtMTUzLjg0ODI4NCAxNzkuNzA4Mzg4TDYyLjU2NjIyMyAxODguNzI5NzI3eiIvPgogICAgPHBhdGggZmlsbD0iI0VBNkMwMCIgZD0iTTEyNC44ODMwNjQgMTg4LjcyOTcyOGw5MS41MzIyMzggMTc5LjcwOTMwMkw2Mi41NjYyMjMgMTg4LjcyOTcyOHoiLz4KICAgIDxwYXRoIGZpbGw9IiNFQTZDMDAiIGQ9Ik0zMDcuOTQ1MTU2IDE4OC43Mjk3MjhMMjE2LjQxMjkxOCAzNjguNDM5MDNsMTUzLjg0OTA3OS0xNzkuNzA5MzAyeiIvPgogICAgPHBhdGggZmlsbD0iI0ZEQUQwMCIgZD0iTTEyNC44ODMwNjQgMTg4LjcyOTcyOEgzMDcuOTQ3NTRMMjE2LjQxNTMwMiAzNjguNDM5MDN6Ii8+CiAgICA8cGF0aCBmaWxsPSIjRkREMjMxIiBkPSJNMjE2LjQxNTMwMiA4OS4xMzQxODVsLTg2LjcxNDU4IDkuMTk0NTgxLTQuODE3NjU4IDkwLjQwMDMxNHoiLz4KICAgIDxwYXRoIGZpbGw9IiNGREQyMzEiIGQ9Ik0yMTYuNDEzNDMzIDg5LjEzNDE4NWw4Ni43MTQ1NzkgOS4xOTQ1ODEgNC44MTc2NTggOTAuNDAwMzE0eiIvPgogICAgPHBhdGggZmlsbD0iI0ZEQUQwMCIgZD0iTTM3MC4yNjE5MDQgMTg4LjcyOTA4bC02Ny4xMzQ0OTktOTAuNDAwMzE0IDQuODE3NjU4IDkwLjQwMDMxNHptLTMwNy42OTU2ODEgMGw2Ny4xMzQ0OTktOTAuNDAwMzE0LTQuODE3NjU4IDkwLjQwMDMxNHoiLz4KICAgIDxwYXRoIGZpbGw9IiNGRUVFQjciIGQ9Ik0yMTYuNDE1MzAyIDg5LjEzNDE4NWwtOTEuNTMyMjM4IDk5LjU5NDg5NUgzMDcuOTQ3NTR6Ii8+CiAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_global__ = __webpack_require__("17x+");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    global: __WEBPACK_IMPORTED_MODULE_2__modules_global__["a" /* default */]
  }
}));

/***/ }),

/***/ "IjD7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var KonamiCode = function KonamiCode(Vue, options) {
  if (typeof options !== 'undefined' && typeof options.callback !== 'function') {
    return;
  }
  var kode = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65];
  var length = kode.length;
  var pos = 0;
  document.addEventListener('keydown', function (event) {
    if (event.keyCode === kode[pos++]) {
      if (length === pos) {
        options.callback();
        pos = 0; // ability to start over
        return false;
      }
    } else {
      pos = 0;
    }
  }, false);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(KonamiCode, { callback: function callback() {
    alert('🎮 SW-4699-5427-7192');
    window.open('https://www.youtube.com/watch?v=cPWBG6_jn4Y');
  }
});

/* harmony default export */ __webpack_exports__["a"] = (KonamiCode);

/***/ }),

/***/ "Iwlo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Showcase__ = __webpack_require__("tDut");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Showcase: __WEBPACK_IMPORTED_MODULE_0__components_Showcase__["a" /* default */] }
});

/***/ }),

/***/ "J6e+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50dc9c6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SVGicons_vue__ = __webpack_require__("h+zE");
function injectStyle (ssrContext) {
  __webpack_require__("U5Vt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50dc9c6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SVGicons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JKjJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Revealer'
});

/***/ }),

/***/ "JSi6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SocialNetworks',

  data: function data() {
    return {
      icons: [{ name: 'twitter', url: 'https://twitter.com/whois_jorge' }, { name: 'github', url: 'https://github.com/whoisjorge' }, { name: 'codepen', url: 'https://www.codepen.io/whoisjorge' }, { name: 'linkedin', url: '#'
        // { name: 'mail', url: 'mailto:email@whoisjorge.me' }
      }]
    };
  }
});

/***/ }),

/***/ "JssR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KGQ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ParticlesJS',

  mounted: function mounted() {
    var _this = this;

    __webpack_require__("JAHf");
    this.$nextTick(function () {
      _this.initParticlesJS();
    });
  },


  methods: {
    initParticlesJS: function initParticlesJS() {
      /* eslint-disable */
      particlesJS('particles-js', {
        'particles': {
          'number': {
            'value': 4,
            'density': {
              'enable': true,
              'value_area': 40
            }
          },
          'color': {
            'value': '#141417'
          },
          'shape': {
            'type': 'triangle',
            'stroke': {
              'width': 0,
              'color': '#ffffff'
            },
            'polygon': {
              'nb_sides': 4
            },
            'image': {
              'src': '',
              'width': 100,
              'height': 100
            }
          },
          'opacity': {
            'value': 0.33,
            'random': false,
            'anim': {
              'enable': false,
              'speed': 1,
              'opacity_min': 0.1,
              'sync': false
            }
          },
          'size': {
            'value': 2,
            'random': true,
            'anim': {
              'enable': false,
              'speed': 90,
              'size_min': 0.1,
              'sync': false
            }
          },
          'line_linked': {
            'enable': true,
            'distance': 120,
            'color': '#0044db',
            'opacity': 0.2,
            'width': 2
          },
          'move': {
            'enable': true,
            'speed': 2,
            'direction': 'none',
            'random': false,
            'straight': false,
            'out_mode': 'out',
            'bounce': false,
            'attract': {
              'enable': false,
              'rotateX': 600,
              'rotateY': 1200
            }
          }
        },
        'interactivity': {
          'detect_on': 'window',
          'events': {
            'onhover': {
              'enable': true,
              'mode': 'grab'
            },
            'onclick': {
              'enable': false,
              'mode': 'push'
            },
            'resize': true
          },
          'modes': {
            'grab': {
              'distance': 140,
              'line_linked': {
                'opacity': 0.2
              }
            },
            'bubble': {
              'distance': 400,
              'size': 40,
              'duration': 2,
              'opacity': 8,
              'speed': 3
            },
            'repulse': {
              'distance': 200,
              'duration': 0.4
            },
            'push': {
              'particles_nb': 2
            },
            'remove': {
              'particles_nb': 4
            }
          }
        },
        'retina_detect': true
      });
    }
  }

});

/***/ }),

/***/ "KJOq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HamburgerMenu_vue__ = __webpack_require__("bnig");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2781999c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_HamburgerMenu_vue__ = __webpack_require__("40wY");
function injectStyle (ssrContext) {
  __webpack_require__("Xdj/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2781999c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HamburgerMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2781999c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_HamburgerMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc4cd84c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("+0bE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc4cd84c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9aD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionContact_vue__ = __webpack_require__("uVx7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60483ef3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SectionContact_vue__ = __webpack_require__("ksu1");
function injectStyle (ssrContext) {
  __webpack_require__("yY/O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60483ef3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionContact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60483ef3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SectionContact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MMwi":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Md12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SectionTitle',
  props: ['seo', 'color']
});

/***/ }),

/***/ "MfHO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContactForm',

  data: function data() {
    return {
      // Form model
      UserName: '',
      UserSubject: '',
      UserMail: '',

      // Robot messages
      name: 'What is your name?',
      subject: 'How can I help?',
      textarea: 'Explain.',
      email: 'Where should I reply?'
    };
  },

  methods: {
    // Name UXified
    UpdateNameLabel: function UpdateNameLabel() {
      this.name = 'Don\'t be shy, I like whole names!';
      if (this.UserName !== '') {
        this.name = 'People normally doesn\'t change it\'s name...';
      }
    },
    ConfirmName: function ConfirmName() {
      if (this.UserName !== '') {
        this.name = 'Nice to meet you, ' + this.UserName.split(' ').slice(0, 1).join(' ') + '!';
      } else {
        this.name = 'What is your name?';
      }
    },


    // Email UXified
    UpdateEmailLabel: function UpdateEmailLabel() {
      this.email = 'Definitely not asdajasj@asdsja.com';
      if (this.UserMail !== '') {
        this.email = 'Don\'t worry, your mail is HTTPS protected!';
      }
    },
    ConfirmEmail: function ConfirmEmail() {
      if (this.UserMail !== '') {
        this.email = 'I won\'t store your direction anywhere.';
      } else {
        this.email = 'Where should I reply?';
      }
    },
    Cool: function Cool() {
      this.subject = 'I want to hear your thoughts.';
      if (this.UserSubject !== '') {
        this.textarea = 'Maybe a more detailed explanation?';
      }
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_main_sass__ = __webpack_require__("jFWc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_main_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_main_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins__ = __webpack_require__("AmHV");










__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
var ಠ_ಠ = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */]));

document.addEventListener('DOMContentLoaded', function () {
  ಠ_ಠ.$mount('#app');
});

/***/ }),

/***/ "OICA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-bounce v-bounce1",style:(_vm.spinnerBasicStyle)},[_c('div',{staticClass:"v-bounce v-bounce2",style:(_vm.spinnerStyle)}),_c('div',{staticClass:"v-bounce v-bounce3",style:(_vm.spinnerStyle)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QauY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"techsigns-list"},_vm._l((_vm.techsigns),function(tech){return _c('figure',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}],staticClass:"techsigns-list__name"},[_c('img',{attrs:{"src":tech.src,"alt":tech.name}}),_c('figcaption',[_vm._v(_vm._s(tech.name))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QcEB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"particles-js"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TimY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U5Vt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U61f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionHello_vue__ = __webpack_require__("+mpb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4503a3d1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SectionHello_vue__ = __webpack_require__("jupa");
function injectStyle (ssrContext) {
  __webpack_require__("UzZY")
  __webpack_require__("98sf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4503a3d1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionHello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4503a3d1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SectionHello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ua3A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UzZY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V8vG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"Tres"}},[_c('SectionTitle',{attrs:{"color":"#F2E059","seo":"03. Some latest projects I've been doing"}},[_c('span',{attrs:{"slot":"number"},slot:"number"},[_vm._v("3")]),_c('span',{attrs:{"slot":"text1"},slot:"text1"},[_vm._v("Portfolio")]),_c('span',{attrs:{"slot":"text2"},slot:"text2"},[_vm._v("SIDE PROJECTS")])]),_c('blockquote',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}]},[_vm._v("These are some of my little front end projects: most of them are "),_c('strong',[_vm._v("open sourced")]),_vm._v(" so you can hack them on  GitHub\n "),_c('div',{staticClass:"brumm"},[_vm._v("🚀")])]),_c('Showcase'),_c('div',{staticClass:"gesture"},[_c('svg',{staticClass:"swipe-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M17.506 12.59c-.452-2.69-2.19-3.17-3.018-3.245-.624-.816-1.514-1.262-2.54-1.262-.22 0-.443.02-.668.06-.607-.725-1.444-1.12-2.397-1.12-.72 0-1.355.225-1.793.482l-1.785-5.61C4.94.732 3.975 0 2.792 0 1.897 0 1.056.427.542 1.128c-.5.677-.625 1.525-.357 2.38l2.253 7.088c-.32.184-.604.43-.84.727-.46.58-.737 1.347-.82 2.28-.124 1.387.335 2.933 1.363 4.595.7 1.12 1.47 1.994 1.79 2.334l1.06 2.48c.26.606.85.988 1.51.988h7.05c.806 0 1.487-.563 1.62-1.354l.01-.05.297-2.468.048-.108c1.58-3.596 2.23-6.025 1.997-7.43zm-3.118 7.18c-.015.037-.026.075-.033.114l-.31 2.57c-.04.247-.255.417-.504.417H6.5c-.205 0-.39-.11-.472-.3L4.92 19.99c-.023-.057-.057-.106-.1-.15-.452-.475-3.158-3.432-2.918-6.13.143-1.597.92-2.114 1.45-2.28.268-.085.413-.373.33-.64l-2.42-7.61c-.38-1.21.584-2.026 1.53-2.026.6 0 1.195.33 1.436 1.097l2.07 6.5c.073.23.284.36.495.36.148 0 .297-.06.4-.2.085-.113.188-.222.31-.316.272-.21.8-.432 1.38-.432.594 0 1.24.237 1.707.96.1.15.264.24.437.24.048 0 .095-.007.143-.02.205-.06.478-.116.78-.116.58 0 1.268.21 1.773 1.01.095.15.258.24.434.24h.07c.607 0 1.822.266 2.166 2.316.32 1.903-1.766 6.43-2.004 6.992z","fill":"#DEDEDE"}}),_c('path',{staticClass:"swipe-arrow",attrs:{"d":"M9.766 3.294h5.505l-1.21 1.213c-.22.22-.22.578 0 .8.11.11.26.164.4.164.15 0 .29-.05.4-.16l2.11-2.11c.22-.22.22-.58 0-.8L14.8.24c-.22-.22-.577-.22-.797 0-.22.22-.22.578 0 .798l1.128 1.13H9.77c-.312 0-.564.252-.564.563 0 .31.252.56.564.56z","fill":"#fff"}})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V9Zr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialNetworks_vue__ = __webpack_require__("JSi6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e81cca16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SocialNetworks_vue__ = __webpack_require__("zc6I");
function injectStyle (ssrContext) {
  __webpack_require__("+h1m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e81cca16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialNetworks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e81cca16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SocialNetworks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ved8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preloader_vue__ = __webpack_require__("uZz3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8bdb74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Preloader_vue__ = __webpack_require__("oiVO");
function injectStyle (ssrContext) {
  __webpack_require__("1nuo")
  __webpack_require__("WFBi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d8bdb74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preloader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8bdb74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Preloader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VyNn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      wiki: 'https://es.wikipedia.org/wiki/Valencia'
    };
  }
});

/***/ }),

/***/ "WFBi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WHoJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"auto-type"},[_vm._v(_vm._s(_vm.typed)),(_vm.shouldShowCursor)?_c('span',{staticClass:"cursor"},[_vm._v(_vm._s(_vm.cursorChar))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WPSa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}],staticClass:"section_title"},[_c('h2',{staticClass:"u-visually--hidden"},[_vm._v(_vm._s(_vm.seo))]),_c('div',{staticClass:"section_title-number_column"},[_c('span',{staticClass:"section_title-number",style:({color: _vm.color})},[_c('span',{staticClass:"section_title-number_el"},[_vm._v("0")]),_c('span',{staticClass:"section_title-number_el"},[_vm._t("number")],2),_c('span',{staticClass:"section_title-number_el"},[_vm._v(".")])]),_c('span',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}],staticClass:"section_title-number_underline",style:({backgroundColor: _vm.color})})]),_c('div',{staticClass:"section_title-title"},[_c('span',{style:({color: _vm.color})},[_vm._t("text1")],2),_c('span',{style:({color: _vm.color})},[_vm._t("text2")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XT9Y":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMwIiBoZWlnaHQ9IjQ1NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMzU2IDI4OS41NjcxMTFjLTExNS4xNzM1ODcgMTg4LjExNjIxLTM2Ni40NjE0MTMtMjQuMzg1NDM1LTI0NC4zMDc2MDktMTU2Ljc2MzUwOUM5NC4yNDE4NDggMzY2LjIwNzA0OCAzMjEuMDk4OTEzIDMzNC44NTQzNDcgMzU2IDI4OS41NjcxMTF6bS0xNzQuNTA1NDM1LTE3Ny42NjUzMUM4My43NzE1MjIgMjAyLjQ3NjI3MyAyNzIuMjM3MzkxIDM1OS4yMzk3ODEgMzU2IDIxOS44OTQ0NGMtMzQuOTAxMDg3IDM0LjgzNjMzNi0xOTUuNDQ2MDg3IDM0LjgzNjMzNi0xNzQuNTA1NDM1LTEwNy45OTI2Mzl6TTI1MS4yOTY3MzkgOTFDMjMzLjg0NjE5NiAxNzQuNjA3MjA1IDMyOC4wNzkxMyAxODUuMDU4MTA1IDM1NiAxNjQuMTU2MzA0IDI3NS43Mjc1IDI0Ny43NjM1MDkgMTg4LjQ3NDc4MyAxMjkuMzE5OTY5IDI1MS4yOTY3MzkgOTF6IiBmaWxsPSIjMjRBOERGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "Xdj/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XrHb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y8L9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Techdesign__ = __webpack_require__("mriT");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Techdesign: __WEBPACK_IMPORTED_MODULE_0__components_Techdesign__["a" /* default */]
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Index__ = __webpack_require__("mlqX");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Index__["a" /* default */]
  }, {
    path: '*',
    redirect: '/'
  }]
}));

/***/ }),

/***/ "Ym6C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZTUR":
/***/ (function(module, exports) {

module.exports = {"projects":[{"id":"0","name":"Angular UIkit","slug":"https://angular-uikit.js.org","skills":["AngularJS","UX/UI design","Integration"],"main_image":"./static/projects/angular-uikit.png"},{"id":"1","name":"Cheatsheets","slug":"https://front-end.js.org","skills":["Jekyll","GitHub","Open Source"],"main_image":"./static/projects/front-end-cheatsheets.png"},{"id":"2","name":"Not Cat GIFs","slug":"https://cats.js.org","skills":["Catcode","Giphy API","Serious stuff"],"main_image":"./static/projects/not-cat-gifs.png"},{"id":"3","name":"Hate Planet","slug":"https://hateplanet.es","skills":["Teaser","Vue.js","Firebase"],"main_image":"./static/projects/hate-planet.png"},{"id":"4","name":"Vue Boilerplate","slug":"https://github.com/whoisjorge/vue-modern-boilerplate","skills":["Vue.js","JavaScript","Starter Project"],"main_image":"./static/projects/vue-boilerplate.png"}]}

/***/ }),

/***/ "ZxQ9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aP63":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aUDs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bA5C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tech-list"},_vm._l((_vm.techs),function(tech){return _c('figure',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}],staticClass:"tech-list__name"},[_c('img',{attrs:{"src":tech.src,"alt":tech.name}}),_c('figcaption',[_vm._v(_vm._s(tech.name))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bgqR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bnig":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hamburger-menu'
});

/***/ }),

/***/ "bxa7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Revealer_vue__ = __webpack_require__("JKjJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57bf9c92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Revealer_vue__ = __webpack_require__("gp86");
function injectStyle (ssrContext) {
  __webpack_require__("+nHM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57bf9c92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Revealer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57bf9c92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Revealer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bydH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "bz9I":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "dUIp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Section02_vue__ = __webpack_require__("Y8L9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69870c58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Section02_vue__ = __webpack_require__("GO/W");
function injectStyle (ssrContext) {
  __webpack_require__("TimY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69870c58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Section02_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69870c58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Section02_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fcCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BounceSpinner_vue__ = __webpack_require__("jLKk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff1b9d72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BounceSpinner_vue__ = __webpack_require__("OICA");
function injectStyle (ssrContext) {
  __webpack_require__("ZxQ9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BounceSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff1b9d72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BounceSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gp86":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}],staticClass:"revealer"},[_c('div',{staticClass:"revealer__motion"},[_c('div',{staticClass:"revealer__block"},[_c('div',{staticClass:"block"}),_c('h4',{staticClass:"revealer__title"},[_vm._t("text")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h+zE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object',{staticStyle:{"display":"none"}},[_c('svg',{staticStyle:{"display":"none"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('symbol',{attrs:{"id":"use-chrome","viewBox":"0 0 305 305"}},[_c('path',{attrs:{"d":"M95.506 152.511c0 31.426 25.567 56.991 56.994 56.991 31.425 0 56.99-25.566 56.99-56.991 0-31.426-25.565-56.993-56.99-56.993-31.427 0-56.994 25.567-56.994 56.993z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M283.733 77.281c.444-.781.436-1.74-.023-2.513-13.275-22.358-32.167-41.086-54.633-54.159C205.922 7.134 179.441.012 152.5.012c-46.625 0-90.077 20.924-119.215 57.407-.643.804-.727 1.919-.212 2.81l42.93 74.355c.45.78 1.28 1.25 2.164 1.25.112 0 .226-.008.339-.023 1.006-.137 1.829-.869 2.083-1.852 8.465-32.799 38.036-55.706 71.911-55.706 2.102 0 4.273.096 6.455.282.071.007.143.01.214.01H281.56c.899 0 1.729-.482 2.173-1.264z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M175.035 224.936c-.621-.803-1.663-1.148-2.646-.876-6.457 1.798-13.148 2.709-19.889 2.709-28.641 0-55.038-16.798-67.251-42.794-.03-.064-.063-.126-.098-.188L23.911 77.719c-.446-.775-1.272-1.25-2.165-1.25h-.013c-.898.005-1.725.49-2.165 1.272C6.767 100.456 0 126.311 0 152.511c0 36.755 13.26 72.258 37.337 99.969 23.838 27.435 56.656 45.49 92.411 50.84.124.019.248.027.371.027.883 0 1.713-.47 2.164-1.25l42.941-74.378c.508-.88.433-1.98-.189-2.783z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M292.175 95.226h-85.974c-1.016 0-1.931.615-2.314 1.555-.384.94-.161 2.02.564 2.73 14.385 14.102 22.307 32.924 22.307 53 0 15.198-4.586 29.824-13.263 42.298-.04.058-.077.117-.112.178l-61.346 106.252c-.449.778-.446 1.737.007 2.513.449.767 1.271 1.237 2.158 1.237h.028c40.37-.45 78.253-16.511 106.669-45.222C289.338 231.032 305 192.941 305 152.511c0-19.217-3.532-37.956-10.498-55.698-.376-.958-1.299-1.587-2.327-1.587z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"use-firefox","viewBox":"0 0 21.821 21.821"}},[_c('path',{attrs:{"d":"M.011 9.122v-.006c-.012.089-.017.124 0 .006zM.011 9.116v.001l.001-.002M21.636 8.263c-.098.75-.205 1.136-.313 1.162 0 0-.038-4.012-1.369-5.343.227 2.34.003 1.397.003 1.408C18.151 2.375 14.781.273 10.929.273 7.711.272 4.831 1.736 2.915 4.03c-.015-.013-.032-.029-.052-.048-.3-.274-.472-1.59-.472-1.59-.001-.005-.003-.009-.003-.013s-.002-.008-.002-.014c0-.002 0-.005-.002-.008-.003.002-.004.006-.008.008-.004.005-.006.008-.01.012-.004.003-.006.009-.01.012-.004.004-.007.009-.011.012-.002.004-.006.009-.01.012-.004.004-.007.009-.01.012-.004.004-.007.009-.012.012-.003.005-.007.008-.01.012-.003.005-.007.009-.011.013-.003.004-.006.008-.01.012-.003.004-.007.008-.01.012-.004.004-.007.008-.011.012-.003.005-.006.008-.011.013 0 0-.56.736-.758 1.537-.132.635-.002.008-.004.011-.001.004-.001.01-.002.014l-.003.012h-.001c-.166.659-.247 1.444-.237 2.364-.007.008-.015.014-.021.022 0 0-.986 1.069-1.15 2.214-.032.227-.052.363-.063.437v.006c-.002.034-.006.068-.007.102.003-.005.007-.01.01-.015.002.086.011.171.033.249l.592-.482c-.008.057-.02.112-.028.17-.188.521-.322 1.065-.389 1.643-.194 1.754.184 3.493 1.121 5.213 0 0 .376.676.605.997.029.046.055.091.087.137l.007.001C4 19.816 7.14 21.549 10.681 21.549c3.134 0 5.95-1.357 7.914-3.52l.038.001c.13-.159.249-.321.372-.482.327-.405.629-.833.897-1.283l-.025.002c.84-1.378 1.391-2.798 1.641-4.264.36-1.445.4-2.692.118-3.74zM2.902 4.047c-.003-.004-.005-.007-.007-.011-.003-.004-.006-.01-.008-.014-.004-.004-.006-.008-.009-.012-.002-.005-.005-.01-.007-.015 0 0 .019.017.042.037-.003.006-.007.01-.011.015zm15.726 3.739c-.222-.345-.515-.571-.889-.684.463 1.798.509 3.282.134 4.452-.257-.78-.493-1.248-.704-1.412.293 2.408-.104 4.19-1.187 5.351.206-.708.288-1.289.241-1.746-1.273 1.906-2.723 2.892-4.344 2.954-.643-.007-1.248-.104-1.818-.288-.011 0-.024-.002-.035-.002-.056-.018-.111-.039-.166-.06l-.001-.001c-.048-.018-.096-.036-.143-.057-.047-.02-.093-.04-.139-.062-.045-.021-.091-.039-.137-.062-.043-.021-.086-.045-.13-.067-.043-.021-.088-.043-.129-.065-.042-.022-.082-.048-.122-.072-.042-.023-.083-.047-.122-.072-.041-.023-.079-.048-.118-.074-.039-.024-.076-.051-.114-.077s-.076-.051-.114-.077c-.036-.027-.071-.055-.107-.082-.035-.027-.072-.054-.106-.082-.036-.028-.07-.056-.104-.085-.034-.027-.067-.058-.101-.086-.033-.028-.067-.056-.1-.087-.032-.028-.063-.06-.095-.09-.032-.028-.064-.059-.094-.089-.025-.024-.05-.047-.074-.071.01.002.02.002.03.002.025.002.049.003.074.005.023.001.048.002.074.003.024.002.048.003.072.004.026.002.05.004.073.004.026.001.05.004.074.004.026 0 .052-.002.077 0 .025 0 .05-.003.076-.003h.076c.024-.001.05 0 .076-.001.025-.001.05-.001.075-.002.027-.002.053-.004.078-.006.026-.002.054-.005.08-.006.025-.002.051-.004.076-.007.027-.002.053-.003.079-.005.027-.004.053-.006.08-.009.027-.003.054-.009.081-.013.026-.004.053-.007.08-.012.027-.003.053-.008.08-.011.027-.005.055-.008.081-.013.028-.005.056-.012.083-.018.027-.005.055-.013.083-.018.029-.007.057-.013.084-.02.028-.006.057-.011.083-.018.029-.008.057-.015.086-.023.027-.008.058-.018.086-.026.03-.008.059-.016.088-.025.028-.009.058-.016.086-.025.03-.01.06-.021.089-.031.03-.012.062-.022.091-.034.03-.011.061-.023.091-.034.029-.012.06-.021.09-.034.032-.015.063-.029.094-.044.032-.014.063-.029.096-.044.032-.015.063-.028.095-.043.014-.008.03-.013.043-.021l.059-.038.106-.069.106-.068.107-.069.107-.069.106-.068.106-.069.107-.068.106-.069.105-.069.107-.069.106-.068.106-.069.049-.031-.004-.005c.18-.067.35-.063.514.015.338-.047.457-.227.344-.529-.164-.226-.412-.431-.729-.61-.694-.361-1.417-.304-2.173.174-.718.405-1.411.39-2.084-.041-.442-.303-.869-.709-1.278-1.218l-.165-.24c-.002.009-.002.02-.002.029 0-.01 0-.021.002-.031v-.005c0-.007.001-.013.001-.021.003-.058.008-.114.017-.165.01-.066.027-.127.046-.185.031-.095.077-.176.133-.243.076-.089.171-.154.29-.194.045-.014.093-.025.143-.033-.029-.003-.053-.004-.081-.007-.076-.006-.142-.013-.204-.018-.079-.007-.15-.013-.204-.017-.04-.003-.074-.005-.101-.006-.037-.003-.073-.004-.109-.007-.058-.002-.113-.006-.169-.01-.016 0-.026-.002-.042-.003-.064-.004-.119-.009-.166-.016.063 0 .127-.001.189 0 .092.005.184.01.277.016.104.005.303.021.589.046.454.042.973.145 1.557.313.098-.56-.031-1.146-.385-1.746v-.01c-.031-.07-.075-.136-.129-.2.021.021.041.042.057.064.028.038.049.076.07.116.007.014.017.026.022.04.016-.015.031-.026.047-.041.023-.021.045-.041.069-.062s.046-.041.07-.061c.023-.021.047-.042.07-.062.022-.021.046-.042.068-.063.023-.019.046-.041.069-.062.024-.02.046-.036.07-.057.023-.02.046-.037.07-.055.023-.02.046-.038.069-.057.022-.019.046-.038.068-.056.023-.018.049-.039.07-.056.023-.019.047-.036.07-.054.024-.018.046-.032.069-.05.024-.018.047-.033.069-.05.023-.017.047-.034.071-.051.023-.016.046-.034.069-.048.023-.017.047-.033.069-.048.025-.016.046-.029.07-.044.024-.014.046-.028.07-.043.023-.013.046-.028.069-.043.023-.014.047-.03.069-.043.006-.003.013-.007.018-.011.019-.011.034-.023.053-.035.023-.015.048-.029.069-.046.027-.022.048-.047.07-.073.027-.032.049-.066.069-.104.03-.057.055-.118.069-.189.005-.005.009-.01.015-.01l.005-.005.02-.02c.108-.159.072-.288-.113-.4-.383.019-1.151-.067-1.16-.068l-.015-.006c-.91-.38-1.413-1.18-1.413-1.18 0 .005-.021-.023-.021-.023l-.029-.037c.002-.002.002-.003.005-.004.005-.003.007-.005.012-.008.003-.002.006-.005.01-.007.002-.002.006-.005.01-.008s.008-.005.011-.008h.002c0-.004.002-.007.002-.009.001-.003.002-.008.002-.011 0-.004.001-.008.003-.012 0-.003-.015.014.002-.011-.172-1.391 1.655-2.306 1.655-2.306s-2.197.615-2.881 1.413l-.101.007.091.002c-.002.002-.005.004-.009.006-.003.004-.005.006-.008.01-.004.003-.006.006-.01.008 0 0-.003.002-.004.003-.004-.002-.01-.003-.015-.005-.014-.004-.027-.008-.041-.012-1.326-.32-2.413.159-2.413.159-.008.001-.015.004-.021.006-.009.003-.015.006-.021.008-.009.003-.015.005-.022.007-.007.003-.013.005-.019.007-.193-.093-.365-.243-.517-.442C4.933 2.03 7.762.572 10.928.572c2.447 0 4.694.872 6.447 2.323-.278-.139-.574-.258-.891-.354-.892-.266-1.956-.42-3.183-.456.538.107.996.242 1.364.41.022.006.045.016.066.021.521.247.87.556 1.034.92-.528-.097-1.007-.061-1.428.103 3.021 1.191 4.454 2.608 4.291 4.247z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M.064 8.728c-.027.128-.041.25-.049.367.02-.146.055-.392.055-.388-.003.007-.005.014-.006.021zM.015 9.095c0 .007-.002.013-.003.02v-.002c0-.006.002-.012.003-.018z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-codepen","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M23 15.7c0-0.1 0-0.1 0-0.2v-7c0-0.1 0-0.1 0-0.2 0 0 0 0 0-0.1s-0.1-0.2-0.1-0.3c0 0 0 0 0 0s0 0 0 0c-0.1-0.1-0.1-0.2-0.2-0.2v0c0 0 0 0 0 0l-10-6.5c0 0-0.1 0-0.1 0s-0.1 0-0.1 0c-0.2-0.1-0.5-0.1-0.7 0 0 0-0.1 0-0.1 0s-0.1 0-0.1 0l-10 6.5c-0.2 0-0.3 0.1-0.4 0.2 0 0 0 0 0 0s0 0 0 0c-0.1 0.2-0.1 0.3-0.2 0.4 0 0 0 0 0 0.1s0 0.1 0 0.2v7c0 0.1 0 0.1 0 0.2 0 0 0 0 0 0.1s0.1 0.2 0.1 0.3c0 0 0 0 0 0s0 0 0 0c0.1 0.1 0.1 0.2 0.2 0.2l10 6.5c0 0 0.1 0 0.1 0s0.1 0 0.1 0 0.2 0.1 0.3 0.1 0.2 0 0.3-0.1c0 0 0.1 0 0.1 0s0.1 0 0.1 0l10-6.5c0.1-0.1 0.2-0.2 0.3-0.2 0 0 0 0 0 0s0 0 0 0c0.3-0.3 0.3-0.4 0.4-0.5 0 0 0 0 0 0zM3 10.4l2.3 1.6-2.3 1.6v-3.2zM12 14.3l-3.3-2.3 3.3-2.3 3.3 2.3-3.3 2.3zM13 8v-4.2l7.2 4.7-3.2 2.3-4-2.8zM11 8l-4 2.8-3.2-2.3 7.2-4.7v4.2zM7 13.2l4 2.8v4.1l-7.2-4.7 3.2-2.2zM13 16l4-2.8 3.2 2.2-7.2 4.8v-4.2zM18.7 12l2.3-1.6v3.2l-2.3-1.6z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-github","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M22.5 8.5c0-1.5-0.5-2.8-1.4-4 0.3-1.3 0.2-2.7-0.3-3.9-0.1-0.3-0.3-0.5-0.6-0.6-0.4-0.1-1.7-0.3-4.4 1.4-2.2-0.5-4.5-0.5-6.6 0-2.7-1.7-4-1.5-4.4-1.4-0.3 0.1-0.5 0.3-0.6 0.6-0.6 1.3-0.7 2.6-0.3 3.9-0.9 1.2-1.4 2.6-1.4 4 0 5.4 3 7.1 5.8 7.7-0.2 0.7-0.3 1.3-0.3 1.9v0.1c-2.1 0.4-2.8-0.4-3.6-1.5-0.5-0.7-1.1-1.5-2.2-1.7-0.5-0.1-1.1 0.2-1.2 0.7s0.2 1.1 0.7 1.2c0.3 0.1 0.7 0.5 1.1 1 0.9 1.2 2.2 2.8 5.2 2.4v1.7c0 0.6 0.4 1 1 1s1-0.4 1-1v-2.9c0 0 0-0.1 0-0.1v-0.9c0-0.7 0.2-1.3 0.7-1.8 0.3-0.3 0.4-0.7 0.2-1-0.1-0.4-0.4-0.6-0.8-0.7-2.9-0.4-5.6-1.3-5.6-6 0-1.2 0.4-2.2 1.2-3.1 0.3-0.3 0.3-0.7 0.2-1-0.3-0.9-0.3-1.7-0.1-2.5 0.5 0.1 1.4 0.4 2.6 1.3 0.3 0.2 0.6 0.2 0.9 0.1 2.1-0.6 4.4-0.6 6.5 0 0.3 0.1 0.6 0 0.8-0.1 1.3-0.9 2.2-1.2 2.6-1.3 0.2 0.8 0.2 1.6-0.1 2.4-0.1 0.4-0.1 0.8 0.2 1 0.8 0.8 1.2 1.9 1.2 3.1 0 4.7-2.7 5.7-5.6 6-0.4 0-0.7 0.3-0.8 0.7s0 0.8 0.2 1c0.5 0.5 0.7 1.2 0.7 1.9v3.9c0 0.6 0.4 1 1 1s1-0.4 1-1v-3.8c0.1-0.7 0-1.3-0.3-1.9 2.4-0.5 5.8-2.1 5.8-7.8z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-twitter","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M23.6 2.2c-0.3-0.2-0.8-0.2-1.1 0-0.7 0.5-1.5 0.9-2.3 1.2-2-1.8-5.1-1.9-7.2-0.1-1.3 1.1-2 2.6-2 4.2-2.9-0.2-5.5-1.7-7.2-4.1-0.2-0.3-0.5-0.4-0.9-0.4s-0.7 0.3-0.8 0.6c-0.1 0.1-1.1 2.5-1 5.4 0.1 2.5 1.1 5.7 4.8 8-1.5 0.7-3.2 1-4.9 1-0.4 0-0.9 0.3-1 0.7s0.1 0.9 0.5 1.1c2.5 1.4 5.2 2.1 7.7 2.1s4.9-0.6 7.1-1.9c4.3-2.4 6.7-7 6.7-12.5 0-0.2 0-0.3 0-0.5 1-1.1 1.7-2.4 2-3.8 0.1-0.4-0.1-0.8-0.4-1zM20.2 6c-0.2 0.2-0.3 0.6-0.3 0.9 0.1 0.2 0.1 0.4 0.1 0.6 0 4.8-2.1 8.7-5.7 10.8-2.8 1.6-6.1 2-9.4 1.2 1.3-0.4 2.5-0.9 3.6-1.7 0.4-0.2 0.5-0.5 0.5-0.9s-0.3-0.7-0.6-0.8c-5.8-2.6-5.6-7.5-5-10 2.2 2.2 5.3 3.5 8.6 3.4 0.5 0 1-0.5 1-1v-1c0-1 0.4-2 1.2-2.7 1.4-1.3 3.7-1.1 4.9 0.3 0.3 0.3 0.7 0.4 1 0.3 0.2-0.1 0.5-0.1 0.7-0.2-0.2 0.3-0.4 0.5-0.6 0.8z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-linkedin","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M16 7c-3.9 0-7 3.1-7 7v7c0 0.6 0.4 1 1 1h4c0.6 0 1-0.4 1-1v-7c0-0.6 0.4-1 1-1s1 0.4 1 1v7c0 0.6 0.4 1 1 1h4c0.6 0 1-0.4 1-1v-7c0-3.9-3.1-7-7-7zM21 20h-2v-6c0-1.7-1.3-3-3-3s-3 1.3-3 3v6h-2v-6c0-2.8 2.2-5 5-5s5 2.2 5 5v6z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6 8h-4c-0.6 0-1 0.4-1 1v12c0 0.6 0.4 1 1 1h4c0.6 0 1-0.4 1-1v-12c0-0.6-0.4-1-1-1zM5 20h-2v-10h2v10z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4 1c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zM4 5c-0.6 0-1-0.4-1-1s0.4-1 1-1 1 0.4 1 1-0.4 1-1 1z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-mail","viewBox":"0 0 100 75"}},[_c('path',{attrs:{"d":"M100 62.5c0 2.2-.6 4.2-1.6 6L66.8 33.2 98.1 5.9c1.2 1.9 1.9 4.2 1.9 6.6v50zM50 39.6l43.5-38c-1.8-1-3.8-1.6-6-1.6h-75c-2.2 0-4.2.6-6 1.6l43.5 38zm12.1-2.3L52 46.1c-.6.5-1.3.8-2.1.8-.7 0-1.5-.3-2.1-.8l-10.1-8.8-32 35.8c1.9 1.2 4.2 1.9 6.6 1.9h75c2.4 0 4.7-.7 6.6-1.9L62.1 37.3zM1.9 5.9C.7 7.8 0 10.1 0 12.5v50c0 2.2.6 4.2 1.6 6l31.6-35.3L1.9 5.9z"}})]),_vm._v(" "),_c('symbol',{attrs:{"viewBox":"0 0 56 56","id":"say-hi"}},[_c('path',{staticClass:"dst3",attrs:{"d":"M7.5 56h-.2c-.2-.1-.3-.3-.3-.5v-7.4H1.5c-.8 0-1.5-.7-1.5-1.5V25.4c0-.8.7-1.5 1.5-1.5h34.7c.8 0 1.5.7 1.5 1.5v21.2c0 .8-.7 1.5-1.5 1.5H15.6l-7.7 7.7c-.2.1-.3.2-.4.2zm-6-31.1c-.3 0-.5.2-.5.5v21.2c0 .3.2.5.5.5h6c.3 0 .5.2.5.5v6.7l7-7c.1-.1.2-.1.4-.1h20.8c.3 0 .5-.2.5-.5V25.4c0-.3-.2-.5-.5-.5H1.5z"}})]),_vm._v(" "),_c('symbol',{attrs:{"viewBox":"0 0 56 56","id":"manage"}},[_c('path',{staticClass:"qst3",attrs:{"d":"M28.6 49.6v-8.1c0-.3-.2-.5-.5-.5H16.2v-7.6c1.5-.2 2.7-1.6 2.7-3.2 0-1.8-1.5-3.2-3.2-3.2s-3.2 1.5-3.2 3.2c0 1.6 1.2 2.9 2.7 3.2V41h-12c-.3 0-.5.2-.5.5v8.1c-1.5.2-2.7 1.6-2.7 3.2C0 54.5 1.5 56 3.2 56c1.8 0 3.2-1.5 3.2-3.2 0-1.6-1.2-2.9-2.7-3.2V42h11.4v7.6c-1.5.2-2.7 1.6-2.7 3.2 0 1.8 1.5 3.2 3.2 3.2s3.2-1.5 3.2-3.2c0-1.6-1.2-2.9-2.7-3.2V42h11.4v7.6c-1.5.2-2.7 1.6-2.7 3.2 0 1.8 1.5 3.2 3.2 3.2 1.8 0 3.2-1.5 3.2-3.2.1-1.6-1.1-3-2.6-3.2zM13.4 30.1c0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2-1 2.2-2.2 2.2-2.2-1-2.2-2.2zM5.5 52.8c0 1.2-1 2.2-2.2 2.2S1 54 1 52.8s1-2.2 2.2-2.2 2.3.9 2.3 2.2zm12.4 0c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2.9 2.2 2.2zM28.1 55c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2 2.2 1 2.2 2.2-1 2.2-2.2 2.2z"}})]),_vm._v(" "),_c('symbol',{attrs:{"viewBox":"0 0 56 56","id":"design"}},[_c('path',{staticClass:"gst3",attrs:{"d":"M37.2 23.3H1.5c-.8 0-1.5.7-1.5 1.5v29.7c0 .8.7 1.5 1.5 1.5h35.7c.8 0 1.5-.7 1.5-1.5V24.8c0-.8-.7-1.5-1.5-1.5zm-35.7 1h35.7c.3 0 .5.2.5.5v7H1v-7c0-.3.2-.5.5-.5zM37.2 55H1.5c-.3 0-.5-.2-.5-.5V32.8h36.7v21.7c0 .3-.2.5-.5.5z"}}),_c('path',{staticClass:"gst3",attrs:{"d":"M15.8 38.6c-.2-.2-.5-.3-.7-.1l-6.5 5c-.1.1-.2.2-.2.4s.1.3.2.4l6.5 5c.1.1.2.1.3.1.2 0 .3-.1.4-.2.2-.2.1-.5-.1-.7l-6-4.6 6-4.6c.2-.2.3-.5.1-.7zm7.8-.1c-.2-.2-.5-.1-.7.1-.2.2-.1.5.1.7l6 4.6-6 4.6c-.2.2-.3.5-.1.7.1.1.2.2.4.2.1 0 .2 0 .3-.1l6.5-5c.1-.1.2-.2.2-.4s-.1-.3-.2-.4l-6.5-5z"}})]),_vm._v(" "),_c('symbol',{attrs:{"viewBox":"0 0 56 56","id":"erp-crm"}},[_c('path',{staticClass:"hst3",attrs:{"d":"M27.2 32.4c-6.1 0-12.3 1.3-12.3 3.8v16c0 2.5 6.2 3.8 12.3 3.8s12.3-1.3 12.3-3.8v-16c0-2.5-6.2-3.8-12.3-3.8zm0 22.6c-7 0-11.3-1.6-11.3-2.8v-3.8c2 1.4 6.7 2.2 11.3 2.2s9.3-.8 11.3-2.2v3.8c0 1.2-4.3 2.8-11.3 2.8zm0-5.3c-7 0-11.3-1.6-11.3-2.8v-3.8c2 1.4 6.7 2.2 11.3 2.2s9.3-.8 11.3-2.2v3.8c0 1.1-4.3 2.8-11.3 2.8zm0-5.4c-7 0-11.3-1.6-11.3-2.8v-3.8c2 1.4 6.7 2.2 11.3 2.2s9.3-.8 11.3-2.2v3.8c0 1.2-4.3 2.8-11.3 2.8zm0-5.3c-7 0-11.3-1.6-11.3-2.8 0-1.2 4.3-2.8 11.3-2.8 7 0 11.3 1.6 11.3 2.8 0 1.2-4.3 2.8-11.3 2.8zm-17 4.2V43l-.1-.1L6 39.7c-.2-.2-.5-.1-.7.1-.2.2-.1.5.1.7l2.9 2.3H.5c-.3 0-.5.2-.5.5s.2.5.5.5h7.7l-2.9 2.3c-.2.2-.3.5-.1.7.1.1.2.2.4.2.1 0 .2 0 .3-.1l4.1-3.2.1-.1c.1-.3.1-.3.1-.4zm43.7-.5h-7.7l2.9-2.3c.2-.2.3-.5.1-.7-.2-.2-.5-.3-.7-.1l-4.1 3.2-.1.1v.4l.1.1 4.1 3.2c.1.1.2.1.3.1.1 0 .3-.1.4-.2.2-.2.1-.5-.1-.7l-2.9-2.3h7.7c.3 0 .5-.2.5-.5s-.2-.3-.5-.3z"}})]),_vm._v(" "),_c('symbol',{attrs:{"viewBox":"0 0 1024 768","id":"repo"}},[_c('path',{attrs:{"d":"M320 256h-64v64h64v-64z m0-128h-64v64h64v-64z m384-128c-32 0-608 0-640 0s-64 32-64 64 0 736 0 768 32 64 64 64 128 0 128 0v128l96-96 96 96v-128s288 0 320 0 64-32 64-64 0-736 0-768-32-64-64-64z m0 800c0 16-15 32-32 32s-288 0-288 0v-64h-192v64s-79 0-96 0-32-17-32-32 0-96 0-96h640s0 80 0 96z m0-160h-512v-576h513l-1 576z m-384-128h-64v64h64v-64z m0-128h-64v64h64v-64z"}})]),_vm._v(" "),_c('symbol',{attrs:{"viewBox":"0 0 17 18","id":"arrow-down"}},[_c('path',{attrs:{"d":"M0 2.93l8 12.14 9-12.14z"}})]),_vm._v(" "),_c('symbol',{attrs:{"viewBox":"0 0 17 18","id":"arrow-left"}},[_c('path',{attrs:{"d":"M2.43 17.5l12.14-8L2.43.5z"}})]),_vm._v(" "),_c('symbol',{attrs:{"viewBox":"0 0 31.49 31.49","id":"arrow-right"}},[_c('path',{attrs:{"d":"M21.205 5.007a1.112 1.112 0 0 0-1.587 0 1.12 1.12 0 0 0 0 1.571l8.047 8.047H1.111A1.106 1.106 0 0 0 0 15.737c0 .619.492 1.127 1.111 1.127h26.554l-8.047 8.032c-.429.444-.429 1.159 0 1.587a1.112 1.112 0 0 0 1.587 0l9.952-9.952a1.093 1.093 0 0 0 0-1.571l-9.952-9.953z"}})]),_vm._v(" "),_c('symbol',{attrs:{"viewBox":"0 0 56 56","id":"cart"}},[_c('path',{staticClass:"est3",attrs:{"d":"M34.3 29.5c-.1-.1-.2-.2-.4-.2H6.4l-1-4.5c-.1-.2-.3-.4-.5-.4H.5c-.3 0-.5.2-.5.5s.2.5.5.5h4l4.7 21.5c.1.2.3.4.5.4h20c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H10.1l-.9-3.9h21.9c.2 0 .4-.2.5-.4l2.7-12.1c.1-.2.1-.3 0-.4zm-3.5 11.9H9.1L6.6 30.3h26.6l-2.4 11.1zm-17.3 8.1c-1.8 0-3.2 1.5-3.2 3.2 0 1.8 1.5 3.2 3.2 3.2 1.8 0 3.2-1.5 3.2-3.2.1-1.7-1.4-3.2-3.2-3.2zm0 5.5c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2 2.2 1 2.2 2.2-.9 2.2-2.2 2.2zm12.1-5.5c-1.8 0-3.2 1.5-3.2 3.2 0 1.8 1.5 3.2 3.2 3.2 1.8 0 3.2-1.5 3.2-3.2 0-1.7-1.5-3.2-3.2-3.2zm0 5.5c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2 2.2 1 2.2 2.2-1 2.2-2.2 2.2z"}})]),_vm._v(" "),_c('symbol',{attrs:{"viewBox":"0 0 17 18","id":"commit"}},[_c('path',{attrs:{"d":"M15.51 13.12h-3.64V6.75a1.14 1.14 0 0 0-1.14-1.15H5.79l1.05-1.05a1.15 1.15 0 0 0 0-1.62 1.14 1.14 0 0 0-1.61 0l-3 3a1.15 1.15 0 0 0 0 1.62l3 3a1.14 1.14 0 0 0 1.61-1.61l-1-1h3.75v5.23h-8.1a1.14 1.14 0 0 0 0 2.29h14a1.14 1.14 0 0 0 0-2.29z"}})]),_vm._v(" "),_c('symbol',{attrs:{"viewBox":"0 0 24 24","id":"hash"}},[_c('path',{attrs:{"d":"M14.209 13.846h-4.63l.31-3.717h4.613l-.293 3.717m4.466-7.564l.326-3.88c.044-.532-.108-1-.456-1.402A1.871 1.871 0 0 0 17.24.332c-.533-.043-1 .109-1.402.456a1.829 1.829 0 0 0-.668 1.305l-.343 4.189h-4.63l.327-3.88c.043-.532-.109-1-.457-1.402A1.83 1.83 0 0 0 8.764.332a1.84 1.84 0 0 0-1.402.456 1.83 1.83 0 0 0-.668 1.305l-.342 4.189H4.086c-.533 0-.99.19-1.37.57-.369.37-.554.821-.554 1.353a1.895 1.895 0 0 0 1.924 1.924h1.956l-.31 3.717H3.466a1.84 1.84 0 0 0-1.353.554c-.38.38-.57.837-.57 1.37 0 .532.19.983.57 1.352.37.38.82.57 1.353.57h1.957l-.327 3.913c-.043.522.11.983.457 1.386.337.413.771.64 1.304.684h.163c.49 0 .918-.168 1.288-.505a1.86 1.86 0 0 0 .62-1.255l.342-4.222h4.613l-.31 3.912c-.043.522.103.983.44 1.386.348.413.788.64 1.32.684h.147c.5 0 .935-.168 1.304-.505a1.86 1.86 0 0 0 .62-1.255l.342-4.222h2.168c.533 0 .984-.19 1.353-.57.38-.37.57-.821.57-1.354 0-.532-.19-.989-.57-1.37a1.84 1.84 0 0 0-1.353-.553h-1.858l.31-3.717h2.168a1.84 1.84 0 0 0 1.353-.554c.38-.38.57-.837.57-1.37 0-.532-.19-.983-.57-1.353-.37-.38-.82-.57-1.353-.57h-1.859z"}})]),_vm._v(" "),_c('symbol',{attrs:{"viewBox":"0 0 32 20","id":"laptop"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M31.177 19.047c-.535.621-1.318.95-2.264.95H3.084c-.943 0-1.725-.328-2.26-.947-.499-.579-.774-1.385-.817-2.396a6.44 6.44 0 0 1 .074-1.296.746.746 0 0 1 .739-.604h1.521V.721a.74.74 0 0 1 .75-.73h25.822a.74.74 0 0 1 .75.73v14.033h1.514c.364 0 .675.255.739.603.043.239.393 2.377-.739 3.69zm-2.264-2.832a.742.742 0 0 1-.751-.731V1.45H3.841v14.034a.741.741 0 0 1-.75.731H1.503c-.019.604.06 1.423.472 1.898.248.285.61.424 1.109.424h25.829c.501 0 .865-.139 1.112-.425.412-.476.489-1.293.47-1.897h-1.582zm-2.074.006h-7.31a1.44 1.44 0 0 1-.295.567c-.186.217-.53.475-1.111.475h-4.236c-.585 0-.93-.26-1.117-.479a1.421 1.421 0 0 1-.291-.563H5.157a.74.74 0 0 1-.75-.73.74.74 0 0 1 .75-.73h8.028c.226 0 .442.091.584.262a.695.695 0 0 1 .154.597.8.8 0 0 0-.002.183h4.166a.785.785 0 0 0 0-.183.717.717 0 0 1 .163-.597.759.759 0 0 1 .575-.262h8.014a.74.74 0 0 1 .751.73.74.74 0 0 1-.751.73z"}})]),_vm._v(" "),_c('symbol',{attrs:{"viewBox":"0 0 129 129","id":"layout"}},[_c('path',{attrs:{"d":"M10.5 58.9h44.3c2.3 0 4.1-1.8 4.1-4.1V10.5c0-2.3-1.8-4.1-4.1-4.1H10.5c-2.3 0-4.1 1.8-4.1 4.1v44.3c0 2.2 1.9 4.1 4.1 4.1zm4.1-44.3h36.1v36.1H14.6V14.6zm108-4.1c0-2.3-1.8-4.1-4.1-4.1H74.2c-2.3 0-4.1 1.8-4.1 4.1v44.3c0 2.3 1.8 4.1 4.1 4.1h44.3c2.3 0 4.1-1.8 4.1-4.1V10.5zm-8.2 40.2H78.3V14.6h36.1v36.1zM10.5 122.6h44.3c2.3 0 4.1-1.8 4.1-4.1V74.2c0-2.3-1.8-4.1-4.1-4.1H10.5c-2.3 0-4.1 1.8-4.1 4.1v44.3c0 2.2 1.9 4.1 4.1 4.1zm4.1-44.3h36.1v36.1H14.6V78.3zm103.9-8.2H74.2c-2.3 0-4.1 1.8-4.1 4.1v44.3c0 2.3 1.8 4.1 4.1 4.1h44.3c2.3 0 4.1-1.8 4.1-4.1V74.2c0-2.2-1.9-4.1-4.1-4.1zm-4.1 44.3H78.3V78.3h36.1v36.1z"}})]),_vm._v(" "),_c('symbol',{attrs:{"viewBox":"0 0 56 56","id":"search"}},[_c('path',{staticClass:"rst3",attrs:{"d":"M14 54.5c-7.7 0-14-6.3-14-14s6.3-14 14-14 14 6.3 14 14c-.1 7.7-6.4 14-14 14zm0-26.9c-7.1 0-13 5.8-13 13s5.8 13 13 13c7.1 0 13-5.8 13-13s-5.9-13-13-13z"}}),_c('path',{staticClass:"rst3",attrs:{"d":"M4.2 40.5h-1C3.2 34.6 8 29.7 14 29.7v1c-5.4 0-9.8 4.4-9.8 9.8zM28.9 56c-.1 0-.3 0-.4-.1l-5.1-5.1c-.2-.2-.2-.5 0-.7s.5-.2.7 0l5.1 5.1c.2.2.2.5 0 .7 0 .1-.1.1-.3.1z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hwhy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMwIiBoZWlnaHQ9IjQ1NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZmlsbD0iI0U3NTgyQiIgZD0iTTIxNiA2Ni42NDNINzMuNDAybDI1LjYyNyAyOTAuMzE0TDIxNiAzODkuMzU3bDExNi45Ny0zMi40IDI1LjYyOC0yOTAuMzE0eiIvPgogICAgPHBhdGggZD0iTTE2OS4wMDMgMTk5LjIxOEgyMTZ2LTM2LjM0aC01MC4xM3oiLz4KICAgIDxwYXRoIGQ9Ik0xNjkuMDAzIDE5OS4yMThsLTMuMTMzLTM2LjM0SDIxNnYtMzUuNjk2aC04OS4zMzVsOS44ODIgMTA3LjczMkgyMTZ2LTM1LjY5NnptNy4zOTEgODEuNjAybC0yLjczMi0yOC4yOTloLTM1LjgzbDUuMjIyIDU1Ljk1NkwyMTYgMzI4LjgxN3YtMzYuOTAxeiIgZmlsbD0iI0VFRSIvPgogICAgPHBhdGggZmlsbD0iI0YzNzEyRSIgZD0iTTIxNiAzNjUuODhoLjE2bDk2LjQwNS0yNy43MzYgMjIuMTczLTI1Mi44NDlIMjE2eiIvPgogICAgPHBhdGggZD0iTTI5OC4yNjUgMTk5LjIxOEgyMTZ2MzUuNjk2aDQzLjc4NGwtNC4yNTggNDYuMDY4TDIxNiAyOTEuOTE2djM2LjkwMmw3Mi42MjUtMjAuMzR6bTMuNTM1LTM2LjM0bDIuNjUxLTM1LjY5NkgyMTZ2MzUuNjk2eiIgZmlsbD0iI0ZGRiIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "iNFr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HamburgerMenu_vue__ = __webpack_require__("KJOq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_easings_js__ = __webpack_require__("yTz5");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Navigation',

  components: { HamburgerMenu: __WEBPACK_IMPORTED_MODULE_2__components_HamburgerMenu_vue__["a" /* default */] },

  methods: {
    // SPA nav...
    goToSection: function goToSection(sectionID) {
      document.getElementById(sectionID).scrollIntoView();
    }
  },

  mounted: function mounted() {
    /* eslint-disable */
    var ShapeOverlays = function () {
      function ShapeOverlays(elm) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ShapeOverlays);

        this.elm = elm;
        this.path = elm.querySelectorAll('path');
        this.numPoints = 90;
        this.duration = 900;
        this.delayPointsArray = [];
        this.delayPointsMax = 200;
        this.delayPerPath = 150;
        this.timeStart = Date.now();
        this.isOpened = false;
        this.isAnimating = false;
      }

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ShapeOverlays, [{
        key: 'toggle',
        value: function toggle() {
          this.isAnimating = true;
          for (var i = 0; i < this.numPoints; i++) {
            this.delayPointsArray[i] = Math.random() * this.delayPointsMax;
          }
          if (this.isOpened === false) {
            this.open();
          } else {
            this.close();
          }
        }
      }, {
        key: 'open',
        value: function open() {
          this.isOpened = true;
          this.elm.classList.add('is-opened');
          this.timeStart = Date.now();
          this.renderLoop();
          //
          setTimeout(function () {
            document.querySelector('main').style.opacity = 0;
            document.querySelector('html').style.overflow = 'hidden';
          }, 350);
        }
      }, {
        key: 'close',
        value: function close() {
          this.isOpened = false;
          this.elm.classList.remove('is-opened');
          this.timeStart = Date.now();
          this.renderLoop();
          //
          setTimeout(function () {
            document.querySelector('main').style.opacity = 1;
            document.querySelector('html').style.overflowY = 'auto';
          }, 900);
        }
      }, {
        key: 'updatePathClose',
        value: function updatePathClose(time) {
          var points = [];
          for (var i = 0; i < this.numPoints; i++) {
            points[i] = (1 - __WEBPACK_IMPORTED_MODULE_3__assets_js_easings_js__["a" /* default */].cubicInOut(Math.min(Math.max(time - this.delayPointsArray[i], 0) / this.duration, 1))) * 100;
          }

          var str = '';
          str += this.isOpened ? 'M 0 0 V ' + points[0] : 'M 0 ' + points[0];
          for (var i = 0; i < this.numPoints - 1; i++) {
            var p = (i + 1) / (this.numPoints - 1) * 100;
            var cp = p - 1 / (this.numPoints - 1) * 100 / 2;
            str += 'C ' + cp + ' ' + points[i] + ' ' + cp + ' ' + points[i + 1] + ' ' + p + ' ' + points[i + 1] + ' ';
          }
          str += this.isOpened ? 'V 100 H 0' : 'V 0 H 0';
          return str;
        }
      }, {
        key: 'updatePathOpen',
        value: function updatePathOpen(time) {
          var points = [];
          for (var i = 0; i < this.numPoints; i++) {
            points[i] = __WEBPACK_IMPORTED_MODULE_3__assets_js_easings_js__["a" /* default */].cubicInOut(Math.min(Math.max(time - this.delayPointsArray[i], 0) / this.duration, 1)) * 100;
          }

          var str = '';
          str += this.isOpened ? 'M 0 0 V ' + points[0] + ' ' : 'M 0 ' + points[0] + ' ';
          for (var i = 0; i < this.numPoints - 1; i++) {
            var p = (i + 1) / (this.numPoints - 1) * 100;
            var cp = p - 1 / (this.numPoints - 1) * 100 / 2;
            str += 'C ' + cp + ' ' + points[i] + ' ' + cp + ' ' + points[i + 1] + ' ' + p + ' ' + points[i + 1] + ' ';
          }
          str += this.isOpened ? 'V 0 H 0' : 'V 100 H 0';
          return str;
        }
      }, {
        key: 'render',
        value: function render() {
          if (this.isOpened) {
            for (var i = 0; i < this.path.length; i++) {
              this.path[i].setAttribute('d', this.updatePathOpen(Date.now() - (this.timeStart + this.delayPerPath * i)));
            }
          } else {
            for (var i = 0; i < this.path.length; i++) {
              this.path[i].setAttribute('d', this.updatePathClose(Date.now() - (this.timeStart + this.delayPerPath * (this.path.length - i - 1))));
            }
          }
        }
      }, {
        key: 'renderLoop',
        value: function renderLoop() {
          var _this = this;

          this.render();
          if (Date.now() - this.timeStart < this.duration + this.delayPerPath * (this.path.length - 1) + this.delayPointsMax) {
            requestAnimationFrame(function () {
              _this.renderLoop();
            });
          } else {
            this.isAnimating = false;
          }
        }
      }]);

      return ShapeOverlays;
    }();

    (function () {
      var elmToggle = document.querySelector('#navigation');
      var elmHamburger = document.querySelector('.hamburger');
      var gNavItems = document.querySelectorAll('.global-menu__item');
      var elmOverlay = document.querySelector('.shape-overlays');
      var overlay = new ShapeOverlays(elmOverlay);

      elmToggle.addEventListener('click', function () {
        if (overlay.isAnimating) {
          return false;
        }
        overlay.toggle();
        //
        if (overlay.isOpened === true) {
          elmHamburger.classList.add('is-opened-navi');
          for (var i = 0; i < gNavItems.length; i++) {
            gNavItems[i].classList.add('is-opened');
          }
        } else {
          elmHamburger.classList.remove('is-opened-navi');
          for (var i = 0; i < gNavItems.length; i++) {
            gNavItems[i].classList.remove('is-opened');
          }
        }
      });
    })();
  } // mounted()

});

/***/ }),

/***/ "iVip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutoType_vue__ = __webpack_require__("iyRo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68e03ce9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AutoType_vue__ = __webpack_require__("WHoJ");
function injectStyle (ssrContext) {
  __webpack_require__("s2d4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68e03ce9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutoType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68e03ce9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AutoType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iyRo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    str: {
      type: String,
      required: true
    },
    typeSpeed: {
      // ms
      type: Number,
      default: 20
    },
    delay: {
      type: Number,
      default: 1000
    },
    cursorChar: {
      type: String,
      default: '|'
    },
    cleanCursor: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      typed: '',
      strIndex: 0,
      sentenceIndex: 0,
      // Should show cursor?
      shouldShowCursor: true
    };
  },
  mounted: function mounted() {
    var _ = this;
    // make typeSpeed not less than 16
    _.typeSpeed = Math.max(_.typeSpeed, 16);
    // delay start to type
    setTimeout(function () {
      _.type();
    }, _.delay);
  },

  methods: {
    type: function type() {
      var _ = this;
      if (_.strIndex === _.str.length) {
        // type finish!
        if (_.cleanCursor) {
          _.shouldShowCursor = false;
        }
        _.$emit('done');
      } else {
        setTimeout(function () {
          _.typed += _.str[_.strIndex];
          _.strIndex += 1;
          _.type();
        }, _.typeSpeed);
      }
    }
  }
});

/***/ }),

/***/ "jFWc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jLKk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'BounceSpinner',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'rgb(29, 29, 50)'
    },
    size: {
      type: String,
      default: '40px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        background: this.color,
        height: this.size,
        width: this.size,
        borderRadius: this.radius,
        opacity: 0.4,
        position: 'absolute',
        top: 0,
        left: 0
      }
    };
  },

  computed: {
    spinnerBasicStyle: function spinnerBasicStyle() {
      return {
        height: this.size,
        width: this.size,
        position: 'relative'
      };
    }
  }
});

/***/ }),

/***/ "jupa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"Hello"}},[_vm._m(0),_c('hr',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}],staticClass:"draw-hr"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hgroup',{staticClass:"landing"},[_c('h1',{staticClass:"u-visually--hidden"},[_vm._v("I am Jorge Moliner, a freelance developer and UX/UI coder passionate about web technologies.")]),_c('h1',{staticClass:"landing__content"},[_c('p',[_vm._v("Hello — I am"),_c('strong',{staticClass:"me"},[_vm._v(" Jorge Moliner")]),_vm._v(",")]),_c('p',[_vm._v("front-end"),_c('strong',[_vm._v(" developer")]),_c('span',[_vm._v(" &")]),_c('strong',[_vm._v(" UX/UI")]),_vm._v(" coder")]),_c('p',[_vm._v("passionate about"),_c('span',{staticClass:"underline"},[_vm._v("web")]),_vm._v("technologies")])]),_c('div',{staticClass:"landing__box"},[_c('h2',[_c('span',[_vm._v("Web &")]),_c('span',[_vm._v("App")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kIxJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Section01_vue__ = __webpack_require__("H2jK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30b2084d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Section01_vue__ = __webpack_require__("ungi");
function injectStyle (ssrContext) {
  __webpack_require__("Ua3A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30b2084d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Section01_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30b2084d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Section01_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ksu1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"Contact"}},[_c('SectionTitle',{attrs:{"color":"#F2E059","seo":"04. Let's get in touch, m8"}},[_c('span',{attrs:{"slot":"number"},slot:"number"},[_vm._v("4")]),_c('span',{attrs:{"slot":"text1"},slot:"text1"},[_vm._v("Contact")]),_c('span',{attrs:{"slot":"text2"},slot:"text2"},[_vm._v("GET IN TOUCH")])]),_c('blockquote',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}]},[_c('strong',[_vm._v("I aim to make web applications as modern and attractive as possible")]),_vm._v(". I am looking forward to create digital products & experiences for local and international brands, small or huge companies, and awesome human beings — like yourself! 👀")]),_c('div',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}],staticClass:"contact-me"},[_c('div',{staticClass:"social"},[_c('p',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}],staticClass:"contact-me_text"},[_vm._v("You can find me on the Internet")]),_c('SocialNetworks')],1),_c('div',{staticClass:"intimate"},[_c('Revealer',[_c('span',{attrs:{"slot":"text"},slot:"text"},[_vm._v(" Let's work together™")]),_c('span',{staticClass:"gradient",attrs:{"slot":"text"},slot:"text"},[_vm._v(" email@whoisjorge.me")])])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mBAZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mlqX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("tk/L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3729937e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("rERY");
function injectStyle (ssrContext) {
  __webpack_require__("XrHb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3729937e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3729937e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mriT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Techdesign_vue__ = __webpack_require__("DRa2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2561bf8b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Techdesign_vue__ = __webpack_require__("QauY");
function injectStyle (ssrContext) {
  __webpack_require__("+vQS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Techdesign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2561bf8b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Techdesign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oiVO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"preloader"}},[_c('vue-progress-bar'),_c('bounce-spinner'),_c('div',{staticClass:"healty-browser"},[_c('p',{staticClass:"type"},[_c('AutoType',{attrs:{"str":'This site works better in modern browsers',"delay":0,"typeSpeed":40,"cleanCursor":true}}),_c('AutoType',{attrs:{"str":' - like Chrome 🤘 ',"delay":1950,"typeSpeed":40,"cleanCursor":true},on:{"done":_vm.typeDone}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p2l6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Form"}},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"on-click-outside",rawName:"v-on-click-outside",value:(_vm.ConfirmName),expression:"ConfirmName"},{name:"model",rawName:"v-model",value:(_vm.UserName),expression:"UserName"}],attrs:{"type":"text","name":"text","required":"required"},domProps:{"value":(_vm.UserName)},on:{"click":_vm.UpdateNameLabel,"input":function($event){if($event.target.composing){ return; }_vm.UserName=$event.target.value}}}),_c('label',{attrs:{"for":"field-text"}},[_vm._v(_vm._s(this.name))])]),_c('div',{staticClass:"form-field subject"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.UserSubject),expression:"UserSubject"}],attrs:{"type":"text","name":"text","required":"required"},domProps:{"value":(_vm.UserSubject)},on:{"click":_vm.Cool,"change":_vm.Cool,"input":function($event){if($event.target.composing){ return; }_vm.UserSubject=$event.target.value}}}),_c('label',[_vm._v(_vm._s(this.subject))])]),_c('div',{staticClass:"form-field"},[_c('textarea',{attrs:{"name":"message","id":"message","cols":"30","rows":"10","placeholder":this.textarea}})]),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"on-click-outside",rawName:"v-on-click-outside",value:(_vm.ConfirmEmail),expression:"ConfirmEmail"},{name:"model",rawName:"v-model",value:(_vm.UserMail),expression:"UserMail"}],attrs:{"type":"text","name":"text","required":"required"},domProps:{"value":(_vm.UserMail)},on:{"click":_vm.UpdateEmailLabel,"input":function($event){if($event.target.composing){ return; }_vm.UserMail=$event.target.value}}}),_c('label',[_vm._v(_vm._s(this.email))])]),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"antispam"},[_vm._v("Leave this empty"),_c('input',{attrs:{"type":"text","name":"url"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pLvN":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMwIiBoZWlnaHQ9IjQ1NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZmlsbD0iIzAwNzJCQSIgZD0iTTIxNS41IDYwLjQxMjc3Nkg2Ny40MTI1TDk0LjA2IDM2MS45MDQ2NjhsMTIxLjQ0IDMzLjY4MjU1NiAxMjEuNDQtMzMuNjgyNTU2IDI2LjY0NzUtMzAxLjQ5MTg5MnoiLz4KICAgIDxwYXRoIGZpbGw9IiMyNEE4REYiIGQ9Ik0yMTUuNSAzNzAuNTcyOTczbC40OTUuMDgyNTU1IDk5LTI3LjQwODM1NCAyMi44NTI1LTI1OC44MTA4MUgyMTUuNXoiLz4KICAgIDxwYXRoIGQ9Ik0xNzIuMjcgMTk3Ljg2NzMyMmwyLjg4NzUgMzcuOTc1NDNIMjE1LjV2LTM3Ljk3NTQzem0yLjA2MjUgODQuNzg0Mjc1bC0yLjgwNS0yOS40NzIyMzVIMTM0LjMybDUuNDQ1IDU4LjI4NDAyOSA3NS43MzUgMjEuMjE2NzA4di0zOC4zODgyMDd6TTEyMi43NyAxMjMuNTY3NTY4bDMuMzgyNSAzNy4xNDk4NzdIMjE1LjV2LTM3LjE0OTg3N3oiIGZpbGw9IiNFQ0VERUQiLz4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0zMDcuMzIyNSAxMjMuNTY3NTY4SDIxNS41djM3LjE0OTg3N2g1Mi42MzVsLTMuMyAzNy4xNDk4NzdIMjE1LjV2MzcuOTc1NDNoNDUuNDU3NWwtNC4zNzI1IDQ3LjU1MTg0My00MS4wODUgMTAuODk3Mjk3djM4LjM4ODIwNmw3NS40MDUtMjEuMjE2NzA3eiIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "rERY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"index","itemprop":"mainContentOfPage"}},[_c('SectionHello'),_c('Section01'),_c('Section02'),_c('Section03'),_c('SectionContact'),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s2d4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sU8K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackTop_vue__ = __webpack_require__("uOWl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e9d7b7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackTop_vue__ = __webpack_require__("1EgX");
function injectStyle (ssrContext) {
  __webpack_require__("aUDs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20e9d7b7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e9d7b7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tDut":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Showcase_vue__ = __webpack_require__("vhVN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5a03f98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Showcase_vue__ = __webpack_require__("y+5U");
function injectStyle (ssrContext) {
  __webpack_require__("Ym6C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5a03f98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Showcase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5a03f98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Showcase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tk/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sections_SectionHello__ = __webpack_require__("U61f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sections_Section01__ = __webpack_require__("kIxJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sections_Section02__ = __webpack_require__("dUIp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sections_Section03__ = __webpack_require__("ucHk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sections_SectionContact__ = __webpack_require__("M9aD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_core_Footer__ = __webpack_require__("uVq+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Index',

  components: {
    SectionHello: __WEBPACK_IMPORTED_MODULE_0__components_sections_SectionHello__["a" /* default */],
    Section01: __WEBPACK_IMPORTED_MODULE_1__components_sections_Section01__["a" /* default */],
    Section02: __WEBPACK_IMPORTED_MODULE_2__components_sections_Section02__["a" /* default */],
    Section03: __WEBPACK_IMPORTED_MODULE_3__components_sections_Section03__["a" /* default */],
    SectionContact: __WEBPACK_IMPORTED_MODULE_4__components_sections_SectionContact__["a" /* default */],
    //
    AppFooter: __WEBPACK_IMPORTED_MODULE_5__components_core_Footer__["a" /* default */]
  }

});

/***/ }),

/***/ "uOWl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_assist__ = __webpack_require__("9W74");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_dom__ = __webpack_require__("xQdF");

//
//
//
//
//
//
//
//
//
//
//
//




var prefixClass = 'BackTop';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BackTop',

  props: {
    height: {
      type: Number,
      default: 1400
    },
    bottom: {
      type: Number,
      default: 20
    },
    left: {
      type: Number,
      default: 40
    },
    duration: {
      type: Number,
      default: 750
    }
  },

  data: function data() {
    return {
      backTop: false
    };
  },
  mounted: function mounted() {
    Object(__WEBPACK_IMPORTED_MODULE_2__assets_js_dom__["b" /* on */])(window, 'scroll', this.handleScroll);
    Object(__WEBPACK_IMPORTED_MODULE_2__assets_js_dom__["b" /* on */])(window, 'resize', this.handleScroll);
  },
  beforeDestroy: function beforeDestroy() {
    Object(__WEBPACK_IMPORTED_MODULE_2__assets_js_dom__["a" /* off */])(window, 'scroll', this.handleScroll);
    Object(__WEBPACK_IMPORTED_MODULE_2__assets_js_dom__["a" /* off */])(window, 'resize', this.handleScroll);
  },


  computed: {
    classes: function classes() {
      return ['' + prefixClass, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, prefixClass + '-show', this.backTop)];
    },
    styles: function styles() {
      return {
        bottom: this.bottom + 'px',
        left: this.left + 'px'
      };
    },
    innerClasses: function innerClasses() {
      return prefixClass + '-inner';
    }
  },

  methods: {
    handleScroll: function handleScroll() {
      this.backTop = window.pageYOffset >= this.height;
    },
    back: function back() {
      var sTop = document.documentElement.scrollTop || document.body.scrollTop;
      Object(__WEBPACK_IMPORTED_MODULE_1__assets_js_assist__["a" /* scrollTop */])(window, sTop, 0, this.duration);
      this.$emit('on-click');
    }
  }

});

/***/ }),

/***/ "uVq+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("VyNn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd9789b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("86rk");
function injectStyle (ssrContext) {
  __webpack_require__("+T00")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bd9789b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd9789b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uVx7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ContactForm_vue__ = __webpack_require__("wCbp");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ContactForm: __WEBPACK_IMPORTED_MODULE_0__components_ContactForm_vue__["a" /* default */] }
});

/***/ }),

/***/ "uZz3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AutoType_vue__ = __webpack_require__("iVip");
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Preloader',

  components: { AutoType: __WEBPACK_IMPORTED_MODULE_0__components_AutoType_vue__["a" /* default */] },

  methods: {
    typeDone: function typeDone() {
      var _this = this;

      // End preloading
      this.$Progress.finish();
      setTimeout(function () {
        _this.$parent.preloading = false;
        // Begin splash animations
        _this.$parent.beginAnimations();
      }, 1);
    }
  },

  created: function created() {
    // Start VueProgressBar
    this.$Progress.start();
  },
  mounted: function mounted() {
    // Disable scrolling
    document.querySelector('html').style.overflowY = 'hidden';
  },
  beforeDestroy: function beforeDestroy() {
    setTimeout(function () {
      // Enable scrolling
      document.querySelector('html').style.overflowY = 'visible';
    }, 1700);
  }
});

/***/ }),

/***/ "ucHk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Section03_vue__ = __webpack_require__("Iwlo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5657566_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Section03_vue__ = __webpack_require__("V8vG");
function injectStyle (ssrContext) {
  __webpack_require__("H5/e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5657566"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Section03_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5657566_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Section03_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ungi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"Uno"}},[_c('SectionTitle',{attrs:{"color":"#F2E059","seo":"01. I am a front end developer"}},[_c('span',{attrs:{"slot":"number"},slot:"number"},[_vm._v("1")]),_c('span',{attrs:{"slot":"text1"},slot:"text1"},[_vm._v("Web & App")]),_c('span',{attrs:{"slot":"text2"},slot:"text2"},[_vm._v("DEVELOPMENT")])]),_c('blockquote',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}],staticClass:"slogan"},[_vm._v("Always on the lookout of new technologies")]),_c('blockquote',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}]},[_vm._v("With a passion for anything between visual and technical, my mission is to code high quality "),_c('strong',[_vm._v("responsive websites")]),_vm._v(" focusing on exceptional "),_c('strong',[_vm._v("user experiences")]),_vm._v(". I am interested in new trends and technologies related to "),_c('strong',[_vm._v("JavaScript")]),_vm._v(" and last "),_c('strong',[_vm._v("CSS3")]),_vm._v(" techniques.")]),_c('Techs'),_c('blockquote',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}],staticClass:"slogan"},[_vm._v("The most important is to know \"how things work\"")]),_c('blockquote',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}]},[_vm._v("As part of my workflow, I love the "),_c('strong',[_vm._v("open source")]),_vm._v(" tools. There is a huge community of developers releasing under\n cool licences that let people freely "),_c('strong',[_vm._v("learn")]),_vm._v(", modify or improve the "),_c('strong',[_vm._v("code")]),_vm._v(".")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v9ZF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionTitle_vue__ = __webpack_require__("Md12");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_910fe65a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SectionTitle_vue__ = __webpack_require__("WPSa");
function injectStyle (ssrContext) {
  __webpack_require__("3Wbp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-910fe65a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_910fe65a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SectionTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vhVN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__("R5/K");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentWork: 0,
      isAnimated: false,
      differenceX: 0,
      differenceY: 0,
      square: null,
      picture: null,
      allowChangeSlide: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getProjects', 'getCurrentProject'])),
  mounted: function mounted() {
    var that = this;
    var AllsliderPictureSquare = this.$el.querySelectorAll('.project .rectangle');
    var AllsliderPicture = this.$el.querySelectorAll('.project .image-container');
    var sliderItem = this.$el.querySelectorAll('.project[data-index="' + this.getCurrentProject.id + '"]');
    var sliderPicture = this.$el.querySelectorAll('.project[data-index="' + this.getCurrentProject.id + '"] .image-container');
    var sliderPictureImg = this.$el.querySelectorAll('.project[data-index="' + this.getCurrentProject.id + '"] .image-container .project-image');
    var sliderPictureSquare = this.$el.querySelectorAll('.project[data-index="' + this.getCurrentProject.id + '"] .rectangle');
    var sliderPictureData = this.$el.querySelectorAll('.project[data-index="' + this.getCurrentProject.id + '"] .project__datas');
    var sliderNav = this.$el.querySelectorAll('#works-nav');

    var initPositionX;
    var initPositionY;
    var checkPostion = true;
    var canScroll = true;

    this.picture = this.$el.querySelectorAll('.project[data-index="' + this.getCurrentProject.id + '"] .image-container')[0];
    this.square = this.$el.querySelectorAll('.project[data-index="' + this.getCurrentProject.id + '"] .rectangle')[0];

    this.$el.addEventListener('mousemove', function (event) {
      if (checkPostion === true) {
        initPositionX = event.clientX;
        initPositionY = event.clientY;
        checkPostion = false;
      } else {
        that.differenceX = event.clientX - initPositionX;
        that.differenceY = event.clientY - initPositionY;
      }
    });

    requestAnimationFrame(this.setParalaxPosition);

    var tl = new __WEBPACK_IMPORTED_MODULE_2_gsap__["b" /* TimelineLite */]();
    tl.set(sliderItem, {
      opacity: 0
    });
    tl.set(sliderPictureImg, {
      opacity: 1
    });
    tl.set(sliderPicture, {
      y: '-150%',
      opacity: 0
    });
    tl.set(sliderPictureSquare, {
      y: '-300%',
      opacity: 0
    });
    tl.set(sliderPictureData, {
      y: '-600px',
      opacity: 0
    });
    tl.set(sliderNav, {
      opacity: 0,
      y: '100px',
      x: '-50%'
    });
    tl.add('switch');
    tl.to(sliderItem, 0.5, {
      opacity: 1,
      zIndex: 3,
      delay: 0,
      ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].linear
    }, 'switch');
    tl.to(sliderPicture, 1, {
      y: '0%',
      opacity: 1,
      delay: 0.6,
      ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].easeOut
    }, 'switch');
    tl.to(sliderPictureSquare, 1, {
      y: '-1%',
      delay: 0.6,
      opacity: 1,
      ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].easeOut
    }, 'switch');
    tl.to(sliderPictureData, 1, {
      y: 0,
      opacity: 1,
      delay: 0.6,
      ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].easeOut
    }, 'switch');
    tl.to(sliderNav, 0.5, {
      opacity: 1,
      y: 0,
      x: '-50%',
      delay: 0.5,
      ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].easeOut
      // onComplete: next
    }, 'switch');

    this.goTo(this.getCurrentProject.id);

    // Handle arrow navigation
    document.addEventListener('keyup', this.handleEventsNav, false);
    this.enableSwipe();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var canScroll = true;

    window.removeEventListener('mousewheel', function (e) {
      if (canScroll) {
        if (e.wheelDelta < 0) {
          this.$router.push('/' + this.getCurrentProject.slug);
          canScroll = false;
        }
      }
    });

    var sliderPicture = this.$el.querySelectorAll('.project[data-index="' + this.currentWork + '"] .image-container');
    var sliderPictureSquare = this.$el.querySelectorAll('.project[data-index="' + this.currentWork + '"] .rectangle');
    var sliderPictureData = this.$el.querySelectorAll('.project[data-index="' + this.currentWork + '"] .project__datas');
    var sliderNav = this.$el.querySelectorAll('#works-nav');

    // Remove arrow navigation listener
    document.removeEventListener('keyup', this.handleEventsNav, false);
    // Remove swipe listener
    this.disableSwipe();

    var tl = new __WEBPACK_IMPORTED_MODULE_2_gsap__["b" /* TimelineLite */]();
    tl.to(sliderPicture, 0.85, {
      y: '-150%',
      opacity: 0,
      ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].easeInOut
    }, 'switch');
    tl.to(sliderPictureSquare, 1, {
      y: '-300%',
      delay: 0.15,
      opacity: 0,
      ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].easeInOut
    }, 'switch');
    tl.to(sliderPictureData, 0.7, {
      y: '-600px',
      opacity: 0,
      delay: 0.23,
      ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].easeInOut
    }, 'switch');
    tl.to(sliderNav, 0.7, {
      opacity: 0,
      y: '100px',
      delay: 0.23,
      ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].easeInOut
      // onComplete: next
    }, 'switch');
    tl.to(this.$el, 0.7, {
      opacity: 1,
      delay: 0.2,
      ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].easeInOut,
      onComplete: next
    }, 'switch');
  },

  methods: {
    goToClick: function goToClick(index) {
      this.isAnimated = true;
      this.goTo(index);
    },
    goTo: function goTo(index) {
      if (index !== this.currentWork) {
        if (index < this.currentWork) {
          this.goPrev(index);
        } else {
          this.goNext(index);
        }
      }
    },
    goPrev: function goPrev(index) {
      var sliderPicture = this.$el.querySelectorAll('.project[data-index="' + index + '"] .image-container .project-image');
      var oldProject = this.$el.querySelectorAll('.project[data-index="' + this.currentWork + '"]');
      var oldProjectSquare = this.$el.querySelectorAll('.project[data-index="' + this.currentWork + '"] .rectangle');
      var matchingProject = this.$el.querySelectorAll('.project[data-index="' + index + '"]');
      var matchingProjectSquare = this.$el.querySelectorAll('.project[data-index="' + index + '"] .rectangle');
      var matchingProjectStore = this.$el.querySelectorAll('.project[data-index="' + index + '"] .store');
      var matchingProjectTitle = this.$el.querySelectorAll('.project[data-index="' + index + '"] .slider-data');
      var matchingProjectStoreTitle = this.$el.querySelectorAll('.project[data-index="' + index + '"] .store-title');

      if (this.isAnimated) {
        var tl = new __WEBPACK_IMPORTED_MODULE_2_gsap__["b" /* TimelineLite */]();
        tl.set(matchingProjectSquare, { x: '-150%', opacity: 0 });
        tl.set(sliderPicture, { opacity: 0 });
        tl.set(matchingProjectStore, { x: '-200%' });
        tl.set(matchingProjectStoreTitle, { x: '-200%' });
        tl.set(matchingProjectTitle, { opacity: '0' });
        tl.add('switch');
        tl.to(oldProjectSquare, 0.45, {
          x: '150%',
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
        tl.to(oldProject, 0.4, {
          zIndex: 1,
          opacity: 0,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
        tl.to(matchingProject, 0.6, {
          zIndex: 3,
          opacity: 1,
          delay: 0.3,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
        tl.to(sliderPicture, 0.3, {
          opacity: 1,
          delay: 0.8,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
        tl.to(matchingProjectSquare, 0.6, {
          x: '-1%',
          opacity: 1,
          delay: 0.7,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
        tl.to(matchingProjectStore, 2.5, {
          x: '101%',
          delay: 0.3,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
        tl.to(matchingProjectStoreTitle, 2.4, {
          x: '101%',
          delay: 0.5,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
        tl.to(matchingProjectTitle, 0, {
          opacity: 1,
          delay: 1,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
      } else {
        var project = parseInt(this.getCurrentProject.id);
        this.$el.querySelectorAll('.project:nth-child(' + project + ')')[0].style.transform = 'translateX(0)';
        this.$el.querySelectorAll('.nav-item[data-index="0"]')[0].className += ' active';
      }

      this.projectHasChanged(index);
    },
    goNext: function goNext(index) {
      var sliderPicture = this.$el.querySelectorAll('.project[data-index="' + index + '"] .image-container .project-image');
      var oldProject = this.$el.querySelectorAll('.project[data-index="' + this.currentWork + '"]');
      var oldProjectSquare = this.$el.querySelectorAll('.project[data-index="' + this.currentWork + '"] .rectangle');
      var matchingProject = this.$el.querySelectorAll('.project[data-index="' + index + '"]');
      var matchingProjectSquare = this.$el.querySelectorAll('.project[data-index="' + index + '"] .rectangle');
      var matchingProjectStore = this.$el.querySelectorAll('.project[data-index="' + index + '"] .store');
      var matchingProjectStoreTitle = this.$el.querySelectorAll('.project[data-index="' + index + '"] .store-title');
      var matchingProjectTitle = this.$el.querySelectorAll('.project[data-index="' + index + '"] .slider-data');

      if (this.isAnimated) {
        var tl = new __WEBPACK_IMPORTED_MODULE_2_gsap__["b" /* TimelineLite */]();
        tl.set(matchingProjectSquare, { x: '150%', opacity: 0 });
        tl.set(sliderPicture, { opacity: 0 });
        tl.set(matchingProjectStore, { x: '100%' });
        tl.set(matchingProjectStoreTitle, { x: '100%' });
        tl.set(matchingProjectTitle, { opacity: '0' });

        tl.to(oldProjectSquare, 0.45, {
          x: '-150%',
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
        tl.to(oldProject, 0.4, {
          zIndex: 1,
          opacity: 0,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
        tl.to(matchingProject, 0.6, {
          zIndex: 3,
          opacity: 1,
          delay: 0.3,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
        tl.to(sliderPicture, 0.3, {
          opacity: 1,
          delay: 0.8,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
        tl.to(matchingProjectSquare, 0.6, {
          x: '0%',
          opacity: 1,
          delay: 0.7,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
        tl.to(matchingProjectStoreTitle, 1.5, {
          x: '-201%',
          delay: 0.5,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
        tl.to(matchingProjectTitle, 0, {
          opacity: 1,
          delay: 1.2,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease
        }, 'switch');
        tl.to(matchingProjectStore, 1.7, {
          x: '-201%',
          delay: 0.1,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["a" /* Power2 */].ease,
          onComplete: function onComplete() {
            this.allowChangeSlide = true;
          }
        }, 'switch');
      } else {
        var project = parseInt(this.getCurrentProject.id) + 1;
        this.$el.querySelectorAll('.project:nth-child(' + project + ')')[0].style.transform = 'translateX(0)';
        this.$el.querySelectorAll('.nav-item[data-index="0"]')[0].className += ' active';
      }

      this.projectHasChanged(index);
    },
    setParalaxPosition: function setParalaxPosition() {
      this.square.style.bottom = -10 + this.differenceY / 50 + 'px';
      this.square.style.right = -17 + this.differenceX / 50 + 'px';
      this.picture.style.bottom = this.differenceY / 30 + 'px';
      this.picture.style.right = this.differenceX / 30 + 'px';
      requestAnimationFrame(this.setParalaxPosition);
    },
    projectHasChanged: function projectHasChanged(index) {
      // Update the current work index
      index = parseInt(index);
      this.currentWork = index;
      this.$store.commit('SET_CURRENT_PROJECT', this.getProjects[index]);
      this.picture = this.$el.querySelectorAll('.project[data-index="' + this.getCurrentProject.id + '"] .image-container')[0];
      this.square = this.$el.querySelectorAll('.project[data-index="' + this.getCurrentProject.id + '"] .rectangle')[0];

      var navItems = this.$el.querySelectorAll('.nav-item');
      // Reset nav items class active
      navItems.forEach(function (item) {
        item.className = 'nav-item';
      });
      // Set the new nav item as active
      this.$el.querySelectorAll('.nav-item[data-index="' + index + '"]')[0].className += ' active';
    },
    handleEventsNav: function handleEventsNav(e) {
      var that = this;
      if (e.keyCode === 37 || e.direction === 4) {
        this.isAnimated = true;
        // You can't go back if you're on the first project
        if (this.currentWork > 0 && this.allowChangeSlide) {
          this.isAnimated = true;
          this.goPrev(this.currentWork - 1);
          this.allowChangeSlide = false;

          setTimeout(function () {
            that.allowChangeSlide = true;
          }, 300);
        }
      }

      if (e.keyCode === 39 || e.direction === 2) {
        this.isAnimated = true;
        // You can't continue if you've reached the last project
        if (this.currentWork < this.getProjects.length - 1 && this.allowChangeSlide) {
          this.isAnimated = true;
          this.goNext(parseInt(this.currentWork + 1));
          this.allowChangeSlide = false;

          setTimeout(function () {
            that.allowChangeSlide = true;
          }, 300);
        }
      }
    },
    disableSwipe: function disableSwipe() {
      this.$refs.swiper.disable('swipe');
    },
    enableSwipe: function enableSwipe() {
      this.$refs.swiper.enable('swipe');
    }
  }
});

/***/ }),

/***/ "wCbp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__ = __webpack_require__("MfHO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19572fea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__ = __webpack_require__("p2l6");
function injectStyle (ssrContext) {
  __webpack_require__("mBAZ")
  __webpack_require__("JssR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19572fea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19572fea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_core_Preloader__ = __webpack_require__("Ved8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_core_Navigation__ = __webpack_require__("2IDB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SVGicons__ = __webpack_require__("J6e+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_json__ = __webpack_require__("ZTUR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//

//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'WHOISJORGE',

  data: function data() {
    return {
      projectsDatas: __WEBPACK_IMPORTED_MODULE_3__assets_data_json___default.a.projects,
      preloading: true
    };
  },

  components: {
    SVGicons: __WEBPACK_IMPORTED_MODULE_2__components_SVGicons__["a" /* default */],
    Preloader: __WEBPACK_IMPORTED_MODULE_0__components_core_Preloader__["a" /* default */],
    Navigation: __WEBPACK_IMPORTED_MODULE_1__components_core_Navigation__["a" /* default */]
  },

  beforeMount: function beforeMount() {
    this.$store.commit('STORE_PROJECTS', this.projectsDatas);
    this.$store.commit('SET_CURRENT_PROJECT', this.projectsDatas[0]);
  },
  mounted: function mounted() {
    this.boot();
  },


  methods: {
    boot: function boot() {
      // Disable app visibility
      document.querySelector('main').classList.add('is-disabled');
    },
    beginAnimations: function beginAnimations() {
      // Enable app visibility
      document.querySelector('main').classList.remove('is-disabled');
    }
  }

});

/***/ }),

/***/ "xQdF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return off; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

var isServer = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$isServer;

// ON
var on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

// OFF
var off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/***/ }),

/***/ "y+5U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component--Showcase"},[_c('v-touch',{ref:"swiper",attrs:{"id":"works"},on:{"swipe":_vm.handleEventsNav}},_vm._l((_vm.getProjects),function(work,index){return _c('div',{key:index,staticClass:"project",attrs:{"data-index":index}},[_c('div',{staticClass:"project-wrapper"},[_c('a',{staticClass:"project__cover",attrs:{"href":work.slug,"target":"_blank"}},[_c('div',{staticClass:"image-container"},[_c('img',{staticClass:"project-image",attrs:{"src":work.main_image}}),_vm._v(" "),_c('span',{staticClass:"store"})]),_vm._v(" "),_c('span',{staticClass:"rectangle"})]),_vm._v(" "),_c('div',{staticClass:"project__datas"},[_c('h2',{staticClass:"slider-title slider-data"},[_vm._v(_vm._s(work.name))]),_vm._v(" "),_c('div',{staticClass:"slider-subtitle slider-data skills color-gray"},_vm._l((work.skills),function(skill,index){return _c('span',{key:index,class:{ last: index === (work.skills.length - 1) }},[_vm._v(_vm._s(skill)+" "),_c('span',{staticClass:"line"},[_vm._v("- ")])])}),0),_vm._v(" "),_c('span',{staticClass:"store-title"})])])])}),0),_vm._v(" "),_c('ul',{attrs:{"id":"works-nav"}},_vm._l((_vm.getProjects),function(work,index){return _c('li',{key:index,staticClass:"nav-item",attrs:{"data-index":index},on:{"click":function($event){return _vm.goToClick(index)}}},[_c('span',{staticClass:"inner"}),_vm._v(" "),_c('span',{staticClass:"work-name slider-subtitle "},[_vm._v(_vm._s(work.name))])])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yNml":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yTz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// These easing functions are based on the code of glsl-easing module.
// https://github.com/glslify/glsl-easings

var ease = {
  exponentialIn: function exponentialIn(t) {
    return t === 0.0 ? t : Math.pow(2.0, 10.0 * (t - 1.0));
  },
  exponentialOut: function exponentialOut(t) {
    return t === 1.0 ? t : 1.0 - Math.pow(2.0, -10.0 * t);
  },
  exponentialInOut: function exponentialInOut(t) {
    return t === 0.0 || t === 1.0 ? t : t < 0.5 ? +0.5 * Math.pow(2.0, 20.0 * t - 10.0) : -0.5 * Math.pow(2.0, 10.0 - t * 20.0) + 1.0;
  },
  sineOut: function sineOut(t) {
    var HALF_PI = 1.5707963267948966;
    return Math.sin(t * HALF_PI);
  },
  circularInOut: function circularInOut(t) {
    return t < 0.5 ? 0.5 * (1.0 - Math.sqrt(1.0 - 4.0 * t * t)) : 0.5 * (Math.sqrt((3.0 - 2.0 * t) * (2.0 * t - 1.0)) + 1.0);
  },
  cubicIn: function cubicIn(t) {
    return t * t * t;
  },
  cubicOut: function cubicOut(t) {
    var f = t - 1.0;
    return f * f * f + 1.0;
  },
  cubicInOut: function cubicInOut(t) {
    return t < 0.5 ? 4.0 * t * t * t : 0.5 * Math.pow(2.0 * t - 2.0, 3.0) + 1.0;
  },
  quadraticOut: function quadraticOut(t) {
    return -t * (t - 2.0);
  },
  quarticOut: function quarticOut(t) {
    return Math.pow(t - 1.0, 3.0) * (1.0 - t) + 1.0;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ease);

/***/ }),

/***/ "yXwe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Techs',

  data: function data() {
    return {
      techs: [{ name: 'HTML5', src: __webpack_require__("hwhy") }, { name: 'CSS3', src: __webpack_require__("pLvN") }, { name: 'JavaScript', src: __webpack_require__("bydH") }, { name: 'Vue', src: __webpack_require__("C7b/") }, { name: 'Webpack', src: __webpack_require__("DPpi") }, { name: 'Bootstrap', src: __webpack_require__("18NO") }, { name: 'Sass', src: __webpack_require__("MMwi") },
      // { name: 'Node.js', src: require('../assets/images/logos/nodejs.svg') },
      { name: 'jQuery', src: __webpack_require__("XT9Y") }, { name: 'Angular2+', src: __webpack_require__("1+i5") }, { name: 'WordPress', src: __webpack_require__("3hlQ") }]
    };
  }
});

/***/ }),

/***/ "yY/O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zc6I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"social-links"},_vm._l((_vm.icons),function(icon){return _c('li',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:(true),expression:"true",modifiers:{"once":true}}],staticClass:"social-links__icon"},[_c('a',{attrs:{"href":icon.url,"target":"_blank","rel":"noopener","aria-label":"icon.name"}},[_c('svg',{staticClass:"svgicon"},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":'#icon-' + icon.name}})])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.066011680b9ea702ed92.js